import React, { useState, useEffect, useCallback, useRef } from "react";
import { 
  CreateTable,
  SuccessMessage,
  FailMessage,
  Loading,
  FormatValueToDecimal,

  BankChartOfAccountsSelect,
  BillPerVendorSelect, BillPerVendorTamperedSelect,
  VendorSelect,
  DateSelect,
  ConfirmationModal,
  DetectMimeTypeFromBase64, HandleFileUpload, DownloadFile,
  PaymentMethodSelect, PaymentMethodSelect2,
  PaymentStatusSelectWithAll,
  DebitCreditSelect,
  ChartOfAccountsSelect,
  CheckbookSelect, CheckbookFromUpdateSelect, 
  BankSelect,
  CHECK_PAYMENT_METHOD,
  TaxationCodeSelect,
  CreateTableMultipleSelectMode
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import axios from 'axios';
import { JournalHeader } from "../Journals/JournalHeader";
import { motion, AnimatePresence } from "framer-motion";
import NoAccess from "../NoAccess";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
// MUI Icons
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ListAltIcon from '@mui/icons-material/ListAlt';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PostAddIcon from '@mui/icons-material/PostAdd';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
const useNewFeature = true;

export const Payments = ({active}) => {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1)
    const lowerValue = value.toLowerCase();

    const filtered = filteredData.filter(
      (item) =>
        item.paymentNumber?.toLowerCase().includes(lowerValue) ||
        item.vendorName1?.toLowerCase().includes(lowerValue)
    );

    setData(filtered);
  };
//#endregion







//#region Filters
  const [showFilterForm, setShowFilterForm] = useState(false);
  const [statusFilter, setStatusFilter] = useState("All");
  const [vendorFilter, setVendorFilter] = useState(null);
  const openFilterForm = () => {
    setShowFilterForm(true);
  }
  const closeFilterForm = () => {
    setShowFilterForm(false);
  }
//#endregion









//#region Variables
  const [selectedData, setSelectedData] = useState(null);

  const [vendor, setVendor] = useState(null);
  const [billPaymentDetails, setBillPaymentDetails] = useState([]);
  const [chartOfAccounts, setChartOfAccounts] = useState([]);
  const [paymentNumber, setPaymentNumber] = useState("xxxxxx");
  const [paidThroughAccount, setPaidThroughAccount] = useState(null);
  const [amount, setAmount] = useState(0);

  const today = new Date().toISOString().split("T")[0];
  const [paymentDate, setPaymentDate] = useState(today);

  const [paymentMethod, setPaymentMethod] = useState(null);
  const [referenceNumber, setReferenceNumber] = useState("");
  const [notes, setNotes] = useState("");
  const [uploadedFile, setUploadedFile] = useState("");
  
  //checkbook transactions
  const [bank, setBank] = useState(null);
  const [checkbook, setCheckbook] = useState(null);
  
  const [selectedRows, setSelectedRows] = useState([])

  const resetVariables = () => {
    setVendor(null);
    setBillPaymentDetails([]);
    setChartOfAccounts([]);
    setPaymentNumber("xxxxxx");
    setPaidThroughAccount(null);
    setAmount(0);
    setPaymentDate(today);
    setPaymentMethod(null);
    setReferenceNumber("");
    setNotes("");
    setUploadedFile("");

    setBank(null);
    setCheckbook(null);

    setSelectedData(null);
    setSelectedRows([])
  }

  const fetchDataById = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/BillPayment/${_data?.id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, []);
//#endregion








// #region Add function
  const [showAddForm, setShowAddForm] = useState(false);
  
  const openAddForm = () => {
    setShowAddForm(true);
  }
  const closeAddForm = () => {
    setShowAddForm(false);
    resetVariables();
  }

  /* const generateNumber = useCallback(async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/BillPayment/generate-number` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return ""
    }
  }, []); */

  const addHandleClick = async () => {
    setLoading(true)

    /* const _number = await generateNumber();
    setPaymentNumber(_number?.number) */

    setLoading(false)
    openAddForm()
  }

  const handleAddData = async () => {
    const data = {
      billPaymentDetails: billPaymentDetails,
      chartOfAccounts: chartOfAccounts,
      vendorId: vendor?.vendorId,
      paymentNumber: paymentNumber,
      paidThroughAccountId: paidThroughAccount?.id,
      amount: amount,
      paymentDate: paymentDate,
      paymentMethodId: paymentMethod?.id,
      referenceNumber: referenceNumber,
      notes: notes,
      uploadedFile: uploadedFile?.base64,
      createdDate: new Date(),
      createdBy: accountData?.id,

      checkbookId: checkbook?.id
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/BillPayment`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion






// #region Update function
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  
  const openUpdateForm = () => {
    setShowUpdateForm(true);
  }
  const closeUpdateForm = () => {
    setShowUpdateForm(false);
    resetVariables();
  }

  const editHandleClick = async (data) => {
    setLoading(true)
    const _data = await fetchDataById(data)
    setSelectedData(_data);

    setBillPaymentDetails(_data.billPaymentDetails ?? []);
    setChartOfAccounts(_data.chartOfAccounts ?? []);
    setVendor(_data.vendor ?? null);
    setPaymentNumber(_data.paymentNumber ?? "");
    setPaidThroughAccount(_data.paidThroughAccount ?? null);
    setAmount(_data.amount ?? 0);
    setPaymentDate(_data.paymentDate ?? null);
    setPaymentMethod(_data.paymentMethod ?? null);
    setReferenceNumber(_data.referenceNumber ?? "");
    setNotes(_data.notes ?? "");
    setUploadedFile(_data.uploadedFile
            ? {
                base64: _data.uploadedFile,
                contentType: DetectMimeTypeFromBase64(
                  _data.uploadedFile
                ),
                fileName: `UploadedFile.${DetectMimeTypeFromBase64(
                  _data.uploadedFile
                ).split("/")[1]}`
              }
            : null)

    setBank(_data.bank ?? null);
    setCheckbook(_data.checkbook ?? null);

    setLoading(false)
    openUpdateForm();
  }

  const handleUpdateData = async () => {
    const data = {
      billPaymentDetails: billPaymentDetails,
      chartOfAccounts: chartOfAccounts,
      vendorId: vendor?.vendorId,
      paymentNumber: paymentNumber,
      paidThroughAccountId: paidThroughAccount?.id,
      amount: amount,
      paymentDate: paymentDate,
      paymentMethodId: paymentMethod?.id,
      referenceNumber: referenceNumber,
      notes: notes,
      uploadedFile: uploadedFile?.base64,
      updatedDate: new Date(),
      updatedBy: accountData?.id,

      checkbookId: checkbook?.id
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/BillPayment/update/${selectedData?.id}`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion








// #region Post function
  const [showPostForm, setShowPostForm] = useState(false);
  
  const openPostForm = () => {
    setShowPostForm(true);
  }
  const closePostForm = () => {
    setShowPostForm(false);
    resetVariables();
  }

  const postHandleClick = async (data) => {
    setLoading(true)
    const _data = await fetchDataById(data)
    setSelectedData(_data);

    setLoading(false)
    openPostForm();
  }
//#endregion










// #region View function
  const [showViewForm, setShowViewForm] = useState(false);
  
  const openViewForm = () => {
    setShowViewForm(true);
  }
  const closeViewForm = () => {
    setShowViewForm(false);
    resetVariables();
  }

  const viewHandleClick = async (data) => {
    setLoading(true)
    const _data = await fetchDataById(data)
    setSelectedData(_data);

    setBillPaymentDetails(_data.billPaymentDetails ?? []);
    setChartOfAccounts(_data.chartOfAccounts ?? []);
    setVendor(_data.vendor ?? null);
    setPaymentNumber(_data.paymentNumber ?? "");
    setPaidThroughAccount(_data.paidThroughAccount ?? null);
    setAmount(_data.amount ?? 0);
    setPaymentDate(_data.paymentDate ?? null);
    setPaymentMethod(_data.paymentMethod ?? null);
    setReferenceNumber(_data.referenceNumber ?? "");
    setNotes(_data.notes ?? "");
    setUploadedFile(_data.uploadedFile
            ? {
                base64: _data.uploadedFile,
                contentType: DetectMimeTypeFromBase64(
                  _data.uploadedFile
                ),
                fileName: `UploadedFile.${DetectMimeTypeFromBase64(
                  _data.uploadedFile
                ).split("/")[1]}`
              }
            : null)

    setBank(_data.bank ?? null);
    setCheckbook(_data.checkbook ?? null);

    setLoading(false)
    openViewForm();
  }
//#endregion








// #region View Bills
  const [selectedBill, setSelectedBill] = useState(null);
  const [showViewBillForm, setShowViewBillForm] = useState(false);
  
  const openViewBillForm = () => {
    setShowViewBillForm(true);
  }
  const closeViewBillForm = () => {
    setShowViewBillForm(false);
    setSelectedBill(null);
  }

  const viewBillHandleClick = async (data) => {
    setLoading(true);
    const _data = await fetchDataById(data);
    setSelectedBill(_data?.billPaymentDetails ?? []);

    setLoading(false)
    openViewBillForm();
  }
// #endregion







// #region Chart Of Accounts
  const [selectedChartOfAccount, setSelectedChartOfAccount] = useState(null);
  const [showViewChartOfAccountForm, setShowViewChartOfAccountForm] = useState(false);
  
  const openViewChartOfAccountForm = () => {
    setShowViewChartOfAccountForm(true);
  }
  const closeViewChartOfAccountForm = () => {
    setShowViewChartOfAccountForm(false);
    setSelectedChartOfAccount(null);
  }

  const viewChartOfAccountHandleClick = async (data) => {
    setLoading(true);
    const _data = await fetchDataById(data);
    setSelectedChartOfAccount(_data?.chartOfAccounts ?? []);

    setLoading(false)
    openViewChartOfAccountForm();
  }
// #endregion











// #region Approve
  const [showStatusChangeForm, setShowStatusChangeForm] = useState(false);
  const [approvalType, setApprovalType] = useState("");
  const openStatusChangeForm = () => {
    setShowStatusChangeForm(true);
  }
  const closeStatusChangeForm = () => {
    setShowStatusChangeForm(false);
    setApprovalType("")
    setSelectedRows([])
  }

  const statusChangeApproveHandleClick = async (data) => {
    setSelectedData(data)
    setApprovalType("Approve")
    openStatusChangeForm()
  }

  const statusChangeDisapproveHandleClick = async (data) => {
    setSelectedData(data)
    setApprovalType("Disapprove")
    openStatusChangeForm()
  }

  const handleStatusChange = async () => {
    try {
      setLoading(true);

      const _data = {
        id: selectedData?.id,
        status: approvalType,
      }

      await axios.post(`${apiUrl}/api/BillPayment/change-status-bulk`, [_data], {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to change data: ${errorMessage}`);
    } finally {
      setLoading(false)
    }
  }
//#endregion







// #region Void Invoice
  const [showVoidForm, setShowVoidForm] = useState(false);

  const openVoidForm = () => {
    setShowVoidForm(true);
  }
  const closeVoidForm = () => {
    setShowVoidForm(false);
    setSelectedData(null);
    setSelectedRows([])
  }

  const voidHandleClick = async (data) => {
    setSelectedData(data);
    openVoidForm();
  }

  const handleVoidStatus = async () => {
    try {
      setLoading(true);

      const _data = {
        id: selectedData?.id,
        status: "Void"
      }

      await axios.post(`${apiUrl}/api/BillPayment/change-status-bulk`, [_data], {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to change data: ${errorMessage}`);
    } finally {
      setLoading(false)
    }
  }
// #endregion







//#region Table data
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const headers = [
    'PAYMENT NUMBER', 
    'VENDOR', 
    'BILL/S', 
    'BILL AMOUNT', 
    'ACCOUNT/S', 
    // 'PAID AMOUNT', 
    // 'PAYMENT DATE', 
    'STATUS', 
    'ACTIONS',
  ]
  const accessors = [
    'paymentNumber', 
    'vendor', 
    'billPaymentDetails', 
    'billPaymentDetailsAmount', 
    'paidThrough', 
    // 'paidThroughAccountName', 
    // 'amount', 
    // 'paymentDate', 
    'status', 
    'actions'
  ]

  const actions = [
    { 
      name: "Approve", 
      tooltip: "approve",
      icon: <ThumbUpAltIcon fontSize="small" />,
      className: "bg-blue-500 hover:bg-blue-600",
      function: statusChangeApproveHandleClick,
      visible: true,
    },
    { 
      name: "Disapprove", 
      tooltip: "disapprove",
      icon: <ThumbDownAltIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: statusChangeDisapproveHandleClick,
      visible: true,
    },
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleClick,
      visible: true,
    },
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleClick,
      visible: true,
    },
    { 
      name: "Void", 
      tooltip: "void",
      icon: <NotInterestedIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: voidHandleClick,
      visible: true,
    },
    { 
      name: "Post", 
      tooltip: "post",
      icon: <PostAddIcon fontSize="small" />,
      className: "bg-orange-500 hover:bg-orange-600",
      function: postHandleClick,
      visible: false,
    },
    { 
      name: "View Bill Payment Detail", 
      tooltip: "view",
      icon: <ListAltIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewBillHandleClick,
      visible: false,
    },
    { 
      name: "View Account", 
      tooltip: "view",
      icon: <PostAddIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewChartOfAccountHandleClick,
      visible: false,
    },
  ];

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${apiUrl}/api/BillPayment/vendor/${vendorFilter?.vendorId ?? "All"}/status/${statusFilter ? statusFilter : "All"}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      setData(response.data)
      setFilteredData(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [vendorFilter, statusFilter]);

  useEffect(() => {
    if(active){
      fetchData();
    }
  }, [active, fetchData])
//#endregion





//#region Change Status
  const [showChangeStatusConfirmation, setShowChangeStatusConfirmation] = useState(false)

  const openChangeStatusConfirmation = (_type) => {
    if(selectedRows.length === 0) {
      setFailMessage("Please select atleast 1 data!");
      return;
    }
    
    setShowChangeStatusConfirmation(true)
    setApprovalType(_type)
  }
  const closeChangeStatusConfirmation = () => {
    setShowChangeStatusConfirmation(false)
    setApprovalType("")
    setSelectedRows([])
  }

  console.log({selectedRows})

  const handleStatusBulkChange = async () => {
    try {
      setLoading(true);

      const _data = selectedRows?.map((item) => {
        return {
          id: item?.id,
          status: approvalType,
        }
      })

      await axios.post(`${apiUrl}/api/BillPayment/change-status-bulk`, _data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem updating data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to change data: ${errorMessage}`);
    } finally {
      setLoading(false)
    }
  }
//#endregion









//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasPayables) {
    return <NoAccess />;
  }
//#endregion


  return (
    <>
      <div className="py-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          {/* Search and Filters */}
          <div className="flex justify-between items-center gap-2 w-full">
            <div className="w-full">
              <input
                type="text"
                placeholder="Search account..."
                className="px-4 py-2 border rounded-lg w-full md:w-2/3 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color"
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
              />
              {/* Add filter dropdowns here if needed */}
            </div>
          </div>
          <div className="flex gap-3 w-full justify-start md:justify-end">
            <button className="bg-white border border-gray-300 text-theme-color hover:bg-gray-100 px-3 py-1 rounded-md flex items-center gap-2 hover:bg-opacity-90 transition"
              onClick={openFilterForm}
            >
              <FilterAltIcon/> Filter
            </button>
            <button onClick={addHandleClick} className="flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md">
              <AddCircleOutlineIcon fontSize="small" /> New Payment
            </button>
          </div>
        </div>

        <div className="flex gap-3 w-full justify-start py-4">
          <button onClick={()=>openChangeStatusConfirmation("Approve")} className="flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-blue-600 transition shadow-md">
            <ThumbUpAltIcon fontSize="small" /> APPROVE
          </button>
          <button onClick={()=>openChangeStatusConfirmation("Disapprove")} className="flex items-center gap-2 bg-red-500 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-red-600 transition shadow-md">
            <ThumbUpAltIcon fontSize="small" /> DISAPPROVE
          </button>
        </div>

        <CreateTableMultipleSelectMode
          tableName={"Bill Payment"}
          headers={headers}
          accessors={accessors}
          data={data}
          actions={actions}

          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={data?.length}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
        />
      </div>
      {useNewFeature ? 
        <>
          <AddUpdateModal2
            visible={showAddForm}
            onClose={closeAddForm}
            onSave={handleAddData}
            modalName={"Add Payment"}

            billPaymentHeader={selectedData}
            data={data}
            billPaymentDetails={billPaymentDetails} setBillPaymentDetails={setBillPaymentDetails}
            chartOfAccounts={chartOfAccounts} setChartOfAccounts={setChartOfAccounts}
            vendor={vendor} setVendor={setVendor}
            paymentNumber={paymentNumber} setPaymentNumber={setPaymentNumber}
            paidThroughAccount={paidThroughAccount} setPaidThroughAccount={setPaidThroughAccount}
            amount={amount} setAmount={setAmount}
            paymentDate={paymentDate} setPaymentDate={setPaymentDate}
            paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod}
            referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
            notes={notes} setNotes={setNotes}
            uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
            bank={bank} setBank={setBank}
            checkbook={checkbook} setCheckbook={setCheckbook}
            isEditable={true}
          />

          <AddUpdateModal2 
            visible={showUpdateForm}
            onClose={closeUpdateForm}
            onSave={handleUpdateData}
            modalName={"Update Payment"}

            billPaymentHeader={selectedData}
            data={data}
            billPaymentDetails={billPaymentDetails} setBillPaymentDetails={setBillPaymentDetails}
            chartOfAccounts={chartOfAccounts} setChartOfAccounts={setChartOfAccounts}
            vendor={vendor} setVendor={setVendor}
            paymentNumber={paymentNumber} setPaymentNumber={setPaymentNumber}
            paidThroughAccount={paidThroughAccount} setPaidThroughAccount={setPaidThroughAccount}
            amount={amount} setAmount={setAmount}
            paymentDate={paymentDate} setPaymentDate={setPaymentDate}
            paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod}
            referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
            notes={notes} setNotes={setNotes}
            uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
            bank={bank} setBank={setBank}
            checkbook={checkbook} setCheckbook={setCheckbook}
            isEditable={true}
          />
        </>
        :
        <>
          <AddUpdateModal 
            visible={showAddForm}
            onClose={closeAddForm}
            onSave={handleAddData}
            modalName={"Add Payment"}

            billPaymentHeader={selectedData}
            data={data}
            billPaymentDetails={billPaymentDetails} setBillPaymentDetails={setBillPaymentDetails}
            vendor={vendor} setVendor={setVendor}
            paymentNumber={paymentNumber} setPaymentNumber={setPaymentNumber}
            paidThroughAccount={paidThroughAccount} setPaidThroughAccount={setPaidThroughAccount}
            amount={amount} setAmount={setAmount}
            paymentDate={paymentDate} setPaymentDate={setPaymentDate}
            paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod}
            referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
            notes={notes} setNotes={setNotes}
            uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
            isEditable={true}
          />

          <AddUpdateModal 
            visible={showUpdateForm}
            onClose={closeUpdateForm}
            onSave={handleUpdateData}
            modalName={"Update Payment"}

            billPaymentHeader={selectedData}
            data={data}
            billPaymentDetails={billPaymentDetails} setBillPaymentDetails={setBillPaymentDetails}
            vendor={vendor} setVendor={setVendor}
            paymentNumber={paymentNumber} setPaymentNumber={setPaymentNumber}
            paidThroughAccount={paidThroughAccount} setPaidThroughAccount={setPaidThroughAccount}
            amount={amount} setAmount={setAmount}
            paymentDate={paymentDate} setPaymentDate={setPaymentDate}
            paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod}
            referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
            notes={notes} setNotes={setNotes}
            uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
            isEditable={true}
          />
        </>
      }

      <ViewModal 
        visible={showViewForm}
        onClose={closeViewForm}
        // onSave={handleViewData}
        modalName={"View Payment"}

        billPaymentHeader={selectedData}
        data={data}
        billPaymentDetails={billPaymentDetails} setBillPaymentDetails={setBillPaymentDetails}
        vendor={vendor} setVendor={setVendor}
        paymentNumber={paymentNumber} setPaymentNumber={setPaymentNumber}
        paidThroughAccount={paidThroughAccount} setPaidThroughAccount={setPaidThroughAccount}
        amount={amount} setAmount={setAmount}
        paymentDate={paymentDate} setPaymentDate={setPaymentDate}
        paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod}
        referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
        notes={notes} setNotes={setNotes}
        uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
        isEditable={false}
      />

      <ViewBillPaymentDetailsModal 
        visible={showViewBillForm}
        onClose={closeViewBillForm}
        // onSave={handleUpdateData}
        modalName={"View Invoice/s"}

        billPaymentDetails={selectedBill} setBillPaymentDetails={setSelectedBill}
      />

      <ViewChartOfAccountsModal 
        visible={showViewChartOfAccountForm}
        onClose={closeViewChartOfAccountForm}
        // onSave={handleUpdateData}
        modalName={"View Account/s"}

        chartOfAccounts={selectedChartOfAccount} setChartOfAccounts={setSelectedChartOfAccount}
      />

      <ConfirmationModal 
        visible={showStatusChangeForm} 
        onClose={closeStatusChangeForm} 
        onSave={handleStatusChange} 
        modalName={"Approval"} 
        message={`Do you want to "${approvalType}" this invoice [ ${selectedData?.paymentNumber ?? ""} ]?.`}
      />

      <CreateJournalModal 
        visible={showPostForm}
        onClose={closePostForm}
        // onSave={handleUpdateData}
        modalName={"Create Journal"}
        isEditable={true}
        data={selectedData}
        fetchData={fetchData}
      />

      <ConfirmationModal 
        visible={showVoidForm} 
        onClose={closeVoidForm} 
        onSave={handleVoidStatus} 
        modalName={"Void"} 
        message={`Do you want to void this [ ${selectedData?.paymentNumber || ""} ]?.`}
      />

      <FilterModal 
        visible={showFilterForm}
        onClose={closeFilterForm}
        modalName={"Filter"}

        vendorFilter={vendorFilter} setVendorFilter={setVendorFilter}
        statusFilter={statusFilter} setStatusFilter={setStatusFilter}
      />

      <ConfirmationModal 
        visible={showChangeStatusConfirmation} 
        onClose={closeChangeStatusConfirmation} 
        onSave={handleStatusBulkChange} 
        modalName={`Confirmation`} 
        message={`Do you want to ${approvalType === "Approve" ? "approve" : "disapprove"} selected data?.`}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
}









//#region AddUpdate/View Modal
const AddUpdateModal = ({
  visible, onClose, onSave, modalName,
  billPaymentHeader,
  billPaymentDetails, setBillPaymentDetails,
  vendor, setVendor,
  paymentNumber, setPaymentNumber,
  paidThroughAccount, setPaidThroughAccount,
  amount, setAmount,
  paymentDate, setPaymentDate,
  paymentMethod, setPaymentMethod,
  referenceNumber, setReferenceNumber,
  notes, setNotes,
  uploadedFile, setUploadedFile,
  isEditable
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [failMessage, setFailMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showBillPaymentDetails, setShowBillPaymentDetails] = useState(true);
  const [totalBillAmount, setTotalBillAmount] = useState(0);


//#region Vendor
  const [showVendorSelectForm, setShowVendorSelectForm] = useState(false);
  const openVendorSelectForm = () => {
    setShowVendorSelectForm(true);
  }
  const closeVendorSelectForm = () => {
    setShowVendorSelectForm(false);
  }
//#endregion






//#region PaidThrough
  const [showPaidThroughAccountSelectForm, setShowPaidThroughAccountSelectForm] = useState(false);
  const openPaidThroughAccountSelectForm = () => {
    setShowPaidThroughAccountSelectForm(true);
  }
  const closePaidThroughAccountSelectForm = () => {
    setShowPaidThroughAccountSelectForm(false);
  }
//#endregion






  const handleSubmit = async () => {
    // Logic updated to match your state requirements
    if (!paymentNumber
      || !paidThroughAccount
      || !paymentDate
      || billPaymentDetails.length <= 0
    ) {
      setFailMessage("Please fill up all required fields. Add at least 1 bill.");
      return;
    }

    if (Number(totalBillAmount) !== Number(amount)) {
      setFailMessage("Please enter an amount that matches the total invoice amount.");
      return;
    }

    await onSave();
    closeModal();
  };

  const closeModal = () => {
    resetLocalVariables();
    onClose();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
    setLoading(false);
    setShowBillPaymentDetails(true);
    setTotalBillAmount(0);
    setSelectedBillPaymentDetail(null)
    setCurrentPageBillPaymentDetail(1)
    setShowAddBillPaymentDetailForm(false)
    setShowUpdateBillPaymentDetailForm(false)
    setShowViewBillPaymentDetailForm(false)
    setShowDeleteBillPaymentDetailForm(false)
  }








//#region Bill Payment Detail
  const [selectedBillPaymentDetail, setSelectedBillPaymentDetail] = useState(null);
  const [currentPageBillPaymentDetail, setCurrentPageBillPaymentDetail] = useState(1);

  const headersBillPaymentDetail = [
    'INVOICE NUMBER', 
    'ORDER NUMBER', 
    'DUE DATE', 
    'TOTAL AMOUNT', 
    'CREDIT AMOUNT', 
    'AMOUNT DUE', 
    'AMOUNT PAID', 
    'ACTIONS'
  ]
  const accessorsBillPaymentDetail = [
    'billNumber', 
    'orderNumber', 
    'dueDate', 
    'totalAmount', 
    'creditNotesAmount', 
    'amountDueBeforePayment', 
    'amountPaid', 
    'actions'
  ]

  const fetchDataBillByBillPaymentHeaderId = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/Bill/vendor/${vendor?.vendorId}/billPaymentHeader/${billPaymentHeader?.id}/id/${_data?.billId}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return
    }
  }, [vendor, billPaymentHeader]);

  const fetchDataBillById = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/Bill/${_data?.billId}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return
    }
  }, []);

  const [showAddBillPaymentDetailForm, setShowAddBillPaymentDetailForm] = useState(false);
  const openAddBillPaymentDetailForm = () => {
    setShowAddBillPaymentDetailForm(true);
  }
  const closeAddBillPaymentDetailForm = () => {
    setShowAddBillPaymentDetailForm(false);
    setSelectedBillPaymentDetail(null)
  }

  const [showUpdateBillPaymentDetailForm, setShowUpdateBillPaymentDetailForm] = useState(false);
  const openUpdateBillPaymentDetailForm = () => {
    setShowUpdateBillPaymentDetailForm(true);
  }
  const closeUpdateBillPaymentDetailForm = () => {
    setShowUpdateBillPaymentDetailForm(false);
    setSelectedBillPaymentDetail(null)
  }

  const editHandleBillPaymentDetailClick = async(_data) => {
    setLoading(true)
    
    if(billPaymentHeader){
      const _bill = await fetchDataBillByBillPaymentHeaderId(_data)
      setSelectedBillPaymentDetail(
        {
          ..._data,
          bill: _bill
        }
      )
    } else {
      const _bill = await fetchDataBillById(_data)
      setSelectedBillPaymentDetail(
        {
          ..._data,
          bill: _bill
        }
      )
    }

    setLoading(false)
    openUpdateBillPaymentDetailForm();
  }

  const [showViewBillPaymentDetailForm, setShowViewBillPaymentDetailForm] = useState(false);
  const openViewBillPaymentDetailForm = () => {
    setShowViewBillPaymentDetailForm(true);
  }
  const closeViewBillPaymentDetailForm = () => {
    setShowViewBillPaymentDetailForm(false);
    setSelectedBillPaymentDetail(null)
  }

  const viewHandleBillPaymentDetailClick = (_data) => {
    setSelectedBillPaymentDetail(_data)
    openViewBillPaymentDetailForm();
  }

  const [showDeleteBillPaymentDetailForm, setShowDeleteBillPaymentDetailForm] = useState(false);
  const openDeleteBillPaymentDetailForm = () => {
    setShowDeleteBillPaymentDetailForm(true);
  }
  const closeDeleteBillPaymentDetailForm = () => {
    setShowDeleteBillPaymentDetailForm(false);
    setSelectedBillPaymentDetail(null)
  }

  const deleteHandleBillPaymentDetailClick = (_data) => {
    setSelectedBillPaymentDetail(_data)
    openDeleteBillPaymentDetailForm();
  }

  const handleDeleteBillPaymentDetail = () => {
    setBillPaymentDetails(prev =>
      prev.filter(item =>
        (item.billNumber  !== selectedBillPaymentDetail.billNumber)
      )
    );
  };

  const actionsBillPaymentDetail = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleBillPaymentDetailClick,
      visible: isEditable === false,
    },
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleBillPaymentDetailClick,
      visible: isEditable === true,
    },
    { 
      name: "Delete", 
      tooltip: "delete",
      icon: <DeleteForeverIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: deleteHandleBillPaymentDetailClick,
      visible: isEditable === true,
    },
  ];

  useEffect(() => {
    const _amount = billPaymentDetails?.reduce((acc, item) => acc + (Number(item.amountPaid) || 0), 0) || 0;
    setTotalBillAmount(_amount)
  }, [billPaymentDetails, setTotalBillAmount])
//#endregion 






  const handleFileChange = async (e) => {
    const fileData = await HandleFileUpload(e);

    if (fileData) {
      setUploadedFile(fileData);
    }
  };






  useEffect(() => {
    const amount = billPaymentDetails?.reduce(
      (total, item) => total + (item.amountDue ?? 0),
      0
    );

    setAmount(amount ?? 0);
  }, [billPaymentDetails, setAmount]);




  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Related Parties */}
                <>
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Related Parties</h3>
                  </div>

                  {isEditable && modalName !== "Update Payment"?
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Vendor <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Vendor"
                          className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${vendor ? `${vendor?.vendorId} - ${vendor?.name1}` : ""}`}
                          readOnly
                        />
                        {!vendor ?
                          <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openVendorSelectForm}>
                            <PersonSearchIcon className="text-white"/>
                          </button> 
                          :
                          <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setVendor(null)}>
                            <RemoveCircleIcon className="text-white"/>
                          </button>
                        }
                      </div>
                    </div>
                    :
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Vendor <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Vendor"
                          className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${vendor ? `${vendor?.vendorId} - ${vendor?.name1}` : ""}`}
                          readOnly
                        />
                      </div>
                    </div>
                  }

                  <div>
                  </div>
                </>
              </div>
                
              {/* Wrap everything in a relative container */}
              <div className="relative mt-10">
                
                {/* The Overlay: Only shows if !vendor */}
                {!vendor && (
                  <div className="absolute inset-0 z-10 flex items-center justify-center bg-gray-50/60 backdrop-blur-[1px] rounded-xl border-2 border-dashed border-gray-200">
                    <div className="bg-white px-6 py-3 rounded-full shadow-xl border border-amber-200 flex items-center gap-3 animate-pulse">
                      <div className="bg-amber-100 p-1 rounded-full">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-600" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <span className="text-sm font-bold text-gray-700 uppercase tracking-tight">
                        Please select vendor first
                      </span>
                    </div>
                  </div>
                )}

                {/* Your Content: We add opacity-40 if no vendor to make it look "disabled" */}
                <div className={`grid grid-cols-1 md:grid-cols-2 gap-6 transition-opacity duration-300 ${!vendor ? 'opacity-40 pointer-events-none p-5' : 'opacity-100'}`}>
                  <>
                    <div className="space-y-4 md:col-span-2 mt-5">
                      <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Payment</h3>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Payment Number <span className="text-red-500">*</span>
                      </label>
                      <input
                        placeholder="0000000"
                        className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                        value={paymentNumber}
                        readOnly
                        onChange={(e) => setPaymentNumber(e.target.value)}
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Payment Date <span className="text-red-500">*</span>
                      </label>
                      <DateSelect data={paymentDate} setData={setPaymentDate} isEditable={true}/>
                    </div>
                  </>
                </div>

                {vendor && (
                  <>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {/* --- Section 2: Bill Payment Details (Expandable) --- */}
                      <div className="md:col-span-2 mt-10">
                        {/* Toggle Header Button */}
                        <button
                          type="button"
                          onClick={() => setShowBillPaymentDetails(!showBillPaymentDetails)}
                          className="flex items-center justify-between w-full border-b pb-2 group hover:border-theme-color transition-colors"
                        >
                          <div className="flex items-center gap-2">
                            <h3 className={`text-xs font-bold uppercase tracking-wider transition-colors ${showBillPaymentDetails ? 'text-theme-color' : 'text-gray-400'}`}>
                              Invoice to pay
                            </h3>
                            {/* Badge showing count */}
                            {billPaymentDetails?.length > 0 && (
                              <span className="bg-gray-200 text-gray-600 text-[10px] px-2 py-0.5 rounded-full font-bold">
                                {billPaymentDetails.length}
                              </span>
                            )}
                          </div>
                          
                          <div className={`transform transition-transform duration-300 text-gray-400 group-hover:text-theme-color ${showBillPaymentDetails ? "rotate-180" : ""}`}>
                            <ExpandMoreIcon /> 
                          </div>
                        </button>

                        {/* Expandable Content Area */}
                        <AnimatePresence>
                          {showBillPaymentDetails && (
                            <motion.div
                              initial={{ height: 0, opacity: 0 }}
                              animate={{ height: "auto", opacity: 1 }}
                              exit={{ height: 0, opacity: 0 }}
                              transition={{ duration: 0.3, ease: "easeInOut" }}
                              className="overflow-hidden"
                            >
                              <div className="py-5 space-y-5">
                                {/* Add button */}
                                <div className="flex gap-3 w-full justify-start">
                                  {isEditable &&
                                    <button 
                                      type="button"
                                      onClick={openAddBillPaymentDetailForm} 
                                      className="flex items-center gap-2 bg-theme-color text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md active:scale-95"
                                    >
                                      <AddCircleOutlineIcon fontSize="small" /> 
                                      New Invoice
                                    </button>
                                  }
                                </div>

                                {/* List of Bill Payment Detail */}
                                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                                  <CreateTable
                                    tableName={"Bill Payment Detail"}
                                    headers={headersBillPaymentDetail}
                                    accessors={accessorsBillPaymentDetail}
                                    data={billPaymentDetails}
                                    actions={actionsBillPaymentDetail}
                                    currentPage={currentPageBillPaymentDetail}
                                    setCurrentPage={setCurrentPageBillPaymentDetail}
                                    itemsPerPage={10}
                                    totalItems={billPaymentDetails?.length}
                                  />
                                </div>
                              </div>
                            </motion.div>
                          )}
                        </AnimatePresence>

                        {/* Summary when collapsed (Optional) */}
                        {!showBillPaymentDetails && billPaymentDetails?.length > 0 && (
                          <motion.p 
                            // initial={{ opacity: 0 }} 
                            // animate={{ opacity: 1 }} 
                            className="text-[11px] text-gray-400 mt-2 italic"
                          >
                            Click to view {billPaymentDetails.length} line items...
                          </motion.p>
                        )}
                      </div>

                      {/* --- Section 3: Final Summary --- */}
                      <div className="md:col-span-2">
                        <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                          
                          {/* Left Side: Details Breakdown */}
                          <div className="flex gap-4 w-full lg:w-auto">
                            <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                              <AccountBalanceWalletIcon className="text-theme-color" />
                            </div>
                            
                            <div className="flex-1 space-y-3">
                              <div>
                                <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                                  Transaction Summary
                                </p>
                                <p className="text-xs text-gray-500">Breakdown of all line items</p>
                              </div>
                            </div>
                          </div>

                          {/* Right Side: Final Total & Status */}
                          <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                            <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                              Final Amount Paid
                            </p>
                            <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                              <span className="text-4xl font-black text-gray-900 tracking-tight">
                                {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalBillAmount)}`}
                              </span>
                            </div>

                            {/* Visual indicator of validation */}
                            {amount > 0 ? (
                              <span className="inline-flex items-center text-[10px] font-bold text-green-600 bg-green-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-green-100">
                                <span className="mr-1">●</span> Ready to Save
                              </span>
                            ) : (
                              <span className="inline-flex items-center text-[10px] font-bold text-amber-600 bg-amber-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-amber-100">
                                <span className="mr-1">○</span> No amount detected
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      

                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">
                          Paid Through Account <span className="text-red-500">*</span>
                        </label>
                        <div className="flex flex-row items-center">
                          <input
                            type="text"
                            placeholder="Select Account"
                            className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                            value={paidThroughAccount?.accountName || ""}
                            readOnly
                          />
                          {!paidThroughAccount ? (
                            <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openPaidThroughAccountSelectForm}>
                              <ManageSearchIcon className="text-white" />
                            </button>
                          ) : (
                            <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={() => setPaidThroughAccount(null)}>
                              <RemoveCircleIcon className="text-white" />
                            </button>
                          )}
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">Amount</label>
                        <input
                          type="number"
                          placeholder="0.00"
                          className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                        />
                        <div className="text-xs text-gray-500 flex items-center gap-1">
                          <span className="font-semibold text-gray-400 italic">
                            {getCurrency?.symbol ?? ""}
                            {FormatValueToDecimal(amount || 0)}
                          </span>
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">Payment Method</label>
                        <PaymentMethodSelect data={paymentMethod} setData={setPaymentMethod} isEditable={true} />
                      </div>

                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">Reference #</label>
                        <input
                          placeholder="0000-0000"
                          className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={referenceNumber}
                          onChange={(e) => setReferenceNumber(e.target.value)}
                        />
                      </div>

                      {/* Full Width: Notes */}
                      <div className="md:col-span-2">
                        <label className="block text-sm font-semibold mb-1 text-gray-700">Notes</label>
                        <textarea
                          rows="3"
                          placeholder="Enter any additional details or remarks..."
                          className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={notes}
                          onChange={(e) => setNotes(e.target.value)}
                          readOnly={!isEditable}
                        />
                      </div>
                    </div>

                    <div className="mt-6 space-y-2">
                      <label className="text-[11px] font-bold uppercase tracking-widest text-gray-400 ml-1">Attachment</label>
                      
                      <div className={`relative group transition-all duration-200 rounded-xl border-2 border-dashed 
                        ${uploadedFile ? 'border-theme-color/30 bg-theme-color/5' : 'border-gray-200 hover:border-theme-color/50 bg-gray-50/50 hover:bg-white'}`}>
                        
                        {/* Hidden Input - clickable over the whole area */}
                        {isEditable && (
                          <input
                            type="file"
                            onChange={handleFileChange}
                            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                          />
                        )}
      
                        <div className="p-4 flex items-center justify-between gap-4">
                          <div className="flex items-center gap-3">
                            {/* Icon based on state */}
                            <div className={`p-2.5 rounded-lg ${uploadedFile ? 'bg-theme-color text-white' : 'bg-gray-200 text-gray-500'}`}>
                              {uploadedFile ? (
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                              ) : (
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                </svg>
                              )}
                            </div>
      
                            <div>
                              <p className={`text-sm font-semibold truncate max-w-[200px] ${uploadedFile ? 'text-gray-800' : 'text-gray-500'}`}>
                                {uploadedFile ? uploadedFile.fileName : "Click to upload file"}
                              </p>
                              <p className="text-[11px] text-gray-400 font-medium">
                                {uploadedFile ? (uploadedFile.contentType || "Document") : "Support any file format"}
                              </p>
                            </div>
                          </div>
      
                          {/* Action Button */}
                          {uploadedFile && (
                            <button
                              type="button"
                              onClick={(e) => { e.stopPropagation(); DownloadFile(uploadedFile); }}
                              className="relative z-20 flex items-center gap-2 px-4 py-2 text-xs font-bold text-theme-color bg-white border border-theme-color/20 rounded-lg shadow-sm hover:bg-theme-color hover:text-white transition-all"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                              </svg>
                              DOWNLOAD
                            </button>
                          )}
                        </div>
                      </div>
                      
                      {!uploadedFile && <p className="text-[10px] text-gray-400 italic ml-1">* No file attached yet</p>}
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Save Transaction
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
      
      <VendorSelect 
        visible={showVendorSelectForm} 
        onClose={closeVendorSelectForm}
        modalName={"Select Vendor"}
        data={vendor} setData={setVendor}
      />
            
      <BankChartOfAccountsSelect 
        visible={showPaidThroughAccountSelectForm} 
        onClose={closePaidThroughAccountSelectForm}
        modalName={"Select Account"}
        data={paidThroughAccount} setData={setPaidThroughAccount}
      />

      <AddUpdateBillPaymentDetailsModal 
        visible={showAddBillPaymentDetailForm} 
        onClose={closeAddBillPaymentDetailForm}
        modalName={"Add Invoice"}
        parentModalName={modalName}
        data={selectedBillPaymentDetail}
        billPaymentHeader={billPaymentHeader}
        billPaymentDetails={billPaymentDetails} setBillPaymentDetails={setBillPaymentDetails}
        vendor={vendor}
        isEditable={true}
      />

      <AddUpdateBillPaymentDetailsModal 
        visible={showUpdateBillPaymentDetailForm} 
        onClose={closeUpdateBillPaymentDetailForm}
        modalName={"Update Invoice"}
        parentModalName={modalName}
        data={selectedBillPaymentDetail}
        billPaymentHeader={billPaymentHeader}
        billPaymentDetails={billPaymentDetails} setBillPaymentDetails={setBillPaymentDetails}
        vendor={vendor}
        isEditable={true}
      />

      <AddUpdateBillPaymentDetailsModal 
        visible={showViewBillPaymentDetailForm} 
        onClose={closeViewBillPaymentDetailForm}
        modalName={"View Invoice"}
        parentModalName={modalName}
        data={selectedBillPaymentDetail}
        billPaymentHeader={billPaymentHeader}
        billPaymentDetails={billPaymentDetails} setBillPaymentDetails={setBillPaymentDetails}
        vendor={vendor}
        isEditable={false}
      />
      
      <ConfirmationModal 
        visible={showDeleteBillPaymentDetailForm} 
        onClose={closeDeleteBillPaymentDetailForm} 
        onSave={handleDeleteBillPaymentDetail} 
        modalName={"Delete"} 
        message={`Do you want to remove this account [ ${selectedBillPaymentDetail?.billNumber} ]?.`}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
      
      { loading && <Loading />}
    </>
  );
};
const AddUpdateModal2 = ({
  visible, onClose, onSave, modalName,
  billPaymentHeader,
  billPaymentDetails, setBillPaymentDetails,
  chartOfAccounts, setChartOfAccounts,
  vendor, setVendor,
  paymentNumber, setPaymentNumber,
  paidThroughAccount, setPaidThroughAccount,
  amount, setAmount,
  paymentDate, setPaymentDate,
  paymentMethod, setPaymentMethod,
  referenceNumber, setReferenceNumber,
  notes, setNotes,
  uploadedFile, setUploadedFile,
  bank, setBank,
  checkbook, setCheckbook,
  isEditable
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [failMessage, setFailMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showBillPaymentDetails, setShowBillPaymentDetails] = useState(true);
  const [totalBillAmount, setTotalBillAmount] = useState(0);
  const [totalEWT, setTotalEWT] = useState(0);
  const [showChartOfAccounts, setShowChartOfAccounts] = useState(true);
  const [totalDebitChartOfAccountAmount, setTotalDebitChartOfAccountAmount] = useState(0);
  const [totalCreditChartOfAccountAmount, setTotalCreditChartOfAccountAmount] = useState(0);


//#region Vendor
  const [showVendorSelectForm, setShowVendorSelectForm] = useState(false);
  const openVendorSelectForm = () => {
    setShowVendorSelectForm(true);
  }
  const closeVendorSelectForm = () => {
    setShowVendorSelectForm(false);
  }
//#endregion






//#region PaidThrough
  const [showPaidThroughAccountSelectForm, setShowPaidThroughAccountSelectForm] = useState(false);
  const openPaidThroughAccountSelectForm = () => {
    setShowPaidThroughAccountSelectForm(true);
  }
  const closePaidThroughAccountSelectForm = () => {
    setShowPaidThroughAccountSelectForm(false);
  }
//#endregion






//#region Bank
  const [showBankSelectForm, setShowBankSelectForm] = useState(false);
  const openBankSelectForm = () => {
    setShowBankSelectForm(true);
  }
  const closeBankSelectForm = () => {
    setShowBankSelectForm(false);
  }
//#endregion






  const handleSubmit = async () => {
    // Logic updated to match your state requirements
    if (!paymentNumber
      // || !paidThroughAccount
      || !paymentDate
      || billPaymentDetails.length <= 0
      || chartOfAccounts.length <= 0
    ) {
      setFailMessage("Please fill up all required fields. Add at least 1 bill. Add at least 1 account");
      return;
    }

    if((paymentMethod?.id === CHECK_PAYMENT_METHOD) 
    && (!bank || !checkbook || !referenceNumber)){
      setFailMessage("Please fill up all bank details.");
      return;
    }

    if (Number(totalBillAmount) !== Number(amount)) {
      setFailMessage("Please enter an amount that matches the total invoice amount.");
      return;
    }

    await onSave();
    closeModal();
  };

  const closeModal = () => {
    resetLocalVariables();
    onClose();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
    setLoading(false);
    setShowBillPaymentDetails(true);
    setTotalBillAmount(0);
    setTotalEWT(0);
    setSelectedBillPaymentDetail(null)
    setCurrentPageBillPaymentDetail(1)
    setShowAddBillPaymentDetailForm(false)
    setShowUpdateBillPaymentDetailForm(false)
    setShowViewBillPaymentDetailForm(false)
    setShowDeleteBillPaymentDetailForm(false)
    setShowChartOfAccounts(true)
    setTotalDebitChartOfAccountAmount(false)
    setTotalCreditChartOfAccountAmount(false)
  }








//#region Bill Payment Detail
  const [selectedBillPaymentDetail, setSelectedBillPaymentDetail] = useState(null);
  const [currentPageBillPaymentDetail, setCurrentPageBillPaymentDetail] = useState(1);

  const headersBillPaymentDetail = [
    'INVOICE NUMBER', 
    'ORDER NUMBER', 
    'DUE DATE', 
    'TOTAL AMOUNT', 
    'CREDIT AMOUNT', 
    'AMOUNT DUE', 
    'AMOUNT PAID', 
    'ACTIONS'
  ]
  const accessorsBillPaymentDetail = [
    'billNumber', 
    'orderNumber', 
    'dueDate', 
    'totalAmount', 
    'creditNotesAmount', 
    'amountDueBeforePayment', 
    'amountPaid', 
    'actions'
  ]

  /* const fetchDataBillByBillPaymentHeaderId = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/Bill/vendor/${vendor?.vendorId}/billPaymentHeader/${billPaymentHeader?.id}/id/${_data?.billId}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return
    }
  }, [vendor, billPaymentHeader]); */

  const fetchDataBillById = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/Bill/${_data?.billId}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return
    }
  }, []);

  const [showAddBillPaymentDetailForm, setShowAddBillPaymentDetailForm] = useState(false);
  const openAddBillPaymentDetailForm = () => {
    setShowAddBillPaymentDetailForm(true);
  }
  const closeAddBillPaymentDetailForm = () => {
    setShowAddBillPaymentDetailForm(false);
    setSelectedBillPaymentDetail(null)
  }

  const [showUpdateBillPaymentDetailForm, setShowUpdateBillPaymentDetailForm] = useState(false);
  const openUpdateBillPaymentDetailForm = () => {
    setShowUpdateBillPaymentDetailForm(true);
  }
  const closeUpdateBillPaymentDetailForm = () => {
    setShowUpdateBillPaymentDetailForm(false);
    setSelectedBillPaymentDetail(null)
  }

  const editHandleBillPaymentDetailClick = async(_data) => {
    setLoading(true)
    
    // if(billPaymentHeader){
    //   const _bill = await fetchDataBillByBillPaymentHeaderId(_data)
    //   setSelectedBillPaymentDetail(
    //     {
    //       ..._data,
    //       bill: _bill
    //     }
    //   )
    // } else {
      const _bill = await fetchDataBillById(_data)
      setSelectedBillPaymentDetail(
        {
          ..._data,
          bill: _bill
        }
      )
    // }

    setLoading(false)
    openUpdateBillPaymentDetailForm();
  }

  const [showViewBillPaymentDetailForm, setShowViewBillPaymentDetailForm] = useState(false);
  const openViewBillPaymentDetailForm = () => {
    setShowViewBillPaymentDetailForm(true);
  }
  const closeViewBillPaymentDetailForm = () => {
    setShowViewBillPaymentDetailForm(false);
    setSelectedBillPaymentDetail(null)
  }

  const viewHandleBillPaymentDetailClick = (_data) => {
    setSelectedBillPaymentDetail(_data)
    openViewBillPaymentDetailForm();
  }

  const [showDeleteBillPaymentDetailForm, setShowDeleteBillPaymentDetailForm] = useState(false);
  const openDeleteBillPaymentDetailForm = () => {
    setShowDeleteBillPaymentDetailForm(true);
  }
  const closeDeleteBillPaymentDetailForm = () => {
    setShowDeleteBillPaymentDetailForm(false);
    setSelectedBillPaymentDetail(null)
  }

  const deleteHandleBillPaymentDetailClick = (_data) => {
    setSelectedBillPaymentDetail(_data)
    openDeleteBillPaymentDetailForm();
  }

  const handleDeleteBillPaymentDetail = () => {
    setBillPaymentDetails(prev =>
      prev.filter(item =>
        (item.billNumber  !== selectedBillPaymentDetail.billNumber)
      )
    );
  };

  const actionsBillPaymentDetail = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleBillPaymentDetailClick,
      visible: isEditable === false,
    },
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleBillPaymentDetailClick,
      visible: isEditable === true,
    },
    { 
      name: "Delete", 
      tooltip: "delete",
      icon: <DeleteForeverIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: deleteHandleBillPaymentDetailClick,
      visible: isEditable === true,
    },
  ];

  useEffect(() => {
    const _amount = billPaymentDetails?.reduce((acc, item) => acc + (Number(item.amountPaid) || 0), 0) || 0;
    const _ewt = billPaymentDetails?.reduce((acc, item) => acc + (Number(item.ewt) || 0), 0) || 0;
    setTotalBillAmount(_amount)
    setTotalEWT(_ewt)
  }, [billPaymentDetails, setTotalBillAmount, setTotalEWT])
//#endregion 







//#region Chart Of Account
  const [selectedChartOfAccount, setSelectedChartOfAccount] = useState(null);
  const [currentPageChartOfAccount, setCurrentPageChartOfAccount] = useState(1);

  const headersChartOfAccount = [
    'ACCOUNT', 
    'DEBIT', 
    'CREDIT', 
    'ACTIONS'
  ]
  const accessorsChartOfAccount = [
    'glAccountName', 
    'debit', 
    'credit', 
    'actions'
  ]

  const [showAddChartOfAccountForm, setShowAddChartOfAccountForm] = useState(false);
  const openAddChartOfAccountForm = () => {
    setShowAddChartOfAccountForm(true);
  }
  const closeAddChartOfAccountForm = () => {
    setShowAddChartOfAccountForm(false);
    setSelectedChartOfAccount(null)
  }

  const [showUpdateChartOfAccountForm, setShowUpdateChartOfAccountForm] = useState(false);
  const openUpdateChartOfAccountForm = () => {
    setShowUpdateChartOfAccountForm(true);
  }
  const closeUpdateChartOfAccountForm = () => {
    setShowUpdateChartOfAccountForm(false);
    setSelectedChartOfAccount(null)
  }

  const editHandleChartOfAccountClick = async(_data) => {
    setLoading(true)

    setSelectedChartOfAccount(_data)

    setLoading(false)
    openUpdateChartOfAccountForm();
  }

  const [showViewChartOfAccountForm, setShowViewChartOfAccountForm] = useState(false);
  const openViewChartOfAccountForm = () => {
    setShowViewChartOfAccountForm(true);
  }
  const closeViewChartOfAccountForm = () => {
    setShowViewChartOfAccountForm(false);
    setSelectedChartOfAccount(null)
  }

  const viewHandleChartOfAccountClick = (_data) => {
    setSelectedChartOfAccount(_data)
    openViewChartOfAccountForm();
  }

  const [showDeleteChartOfAccountForm, setShowDeleteChartOfAccountForm] = useState(false);
  const openDeleteChartOfAccountForm = () => {
    setShowDeleteChartOfAccountForm(true);
  }
  const closeDeleteChartOfAccountForm = () => {
    setShowDeleteChartOfAccountForm(false);
    setSelectedChartOfAccount(null)
  }

  const deleteHandleChartOfAccountClick = (_data) => {
    setSelectedChartOfAccount(_data)
    openDeleteChartOfAccountForm();
  }

  const handleDeleteChartOfAccount = () => {
    setChartOfAccounts(prev =>
      prev.filter(item =>
        (item.glAccountId  !== selectedChartOfAccount.glAccountId)
      )
    );
  };

  const actionsChartOfAccount = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleChartOfAccountClick,
      visible: isEditable === false,
    },
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleChartOfAccountClick,
      visible: isEditable === true,
    },
    { 
      name: "Delete", 
      tooltip: "delete",
      icon: <DeleteForeverIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: deleteHandleChartOfAccountClick,
      visible: isEditable === true,
    },
  ];

  useEffect(() => {
    const _amount = chartOfAccounts?.filter(i => i.debitCredit === "Debit").reduce((acc, item) => acc + (Number(item.amount) || 0), 0) || 0;
    setTotalDebitChartOfAccountAmount(_amount)
  }, [chartOfAccounts, setTotalDebitChartOfAccountAmount])

  useEffect(() => {
    const _amount = chartOfAccounts?.filter(i => i.debitCredit === "Credit").reduce((acc, item) => acc + (Number(item.amount) || 0), 0) || 0;
    setTotalCreditChartOfAccountAmount(_amount)
  }, [chartOfAccounts, setTotalCreditChartOfAccountAmount])
//#endregion 






  const handleFileChange = async (e) => {
    const fileData = await HandleFileUpload(e);

    if (fileData) {
      setUploadedFile(fileData);
    }
  };






  useEffect(() => {
    const amount = billPaymentDetails?.reduce(
      (total, item) => total + (item.amountDueBeforePayment ?? 0),
      0
    );

    setAmount(amount ?? 0);
  }, [billPaymentDetails, setAmount]);




  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Related Parties */}
                <>
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Related Parties</h3>
                  </div>

                  {isEditable && modalName !== "Update Payment"?
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Vendor <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Vendor"
                          className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${vendor ? `${vendor?.vendorId} - ${vendor?.name1}` : ""}`}
                          readOnly
                        />
                        {!vendor ?
                          <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openVendorSelectForm}>
                            <PersonSearchIcon className="text-white"/>
                          </button> 
                          :
                          <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setVendor(null)}>
                            <RemoveCircleIcon className="text-white"/>
                          </button>
                        }
                      </div>
                    </div>
                    :
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Vendor <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Vendor"
                          className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${vendor ? `${vendor?.vendorId} - ${vendor?.name1}` : ""}`}
                          readOnly
                        />
                      </div>
                    </div>
                  }

                  <div>
                  </div>
                </>
              </div>
                
              {/* Wrap everything in a relative container */}
              <div className="relative mt-10">
                
                {/* The Overlay: Only shows if !vendor */}
                {!vendor && (
                  <div className="absolute inset-0 z-10 flex items-center justify-center bg-gray-50/60 backdrop-blur-[1px] rounded-xl border-2 border-dashed border-gray-200">
                    <div className="bg-white px-6 py-3 rounded-full shadow-xl border border-amber-200 flex items-center gap-3 animate-pulse">
                      <div className="bg-amber-100 p-1 rounded-full">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-600" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <span className="text-sm font-bold text-gray-700 uppercase tracking-tight">
                        Please select vendor first
                      </span>
                    </div>
                  </div>
                )}

                {/* Your Content: We add opacity-40 if no vendor to make it look "disabled" */}
                <div className={`grid grid-cols-1 md:grid-cols-2 gap-6 transition-opacity duration-300 ${!vendor ? 'opacity-40 pointer-events-none p-5' : 'opacity-100'}`}>
                  <>
                    <div className="space-y-4 md:col-span-2 mt-5">
                      <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Payment</h3>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Payment Number <span className="text-red-500">*</span>
                      </label>
                      <input
                        placeholder="0000000"
                        className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                        value={paymentNumber}
                        readOnly
                        onChange={(e) => setPaymentNumber(e.target.value)}
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Payment Date <span className="text-red-500">*</span>
                      </label>
                      <DateSelect data={paymentDate} setData={setPaymentDate} isEditable={true}/>
                    </div>
                  </>
                </div>

                {vendor && (
                  <>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {/* --- Section 2: Bill Payment Details (Expandable) --- */}
                      <div className="md:col-span-2 mt-10">
                        {/* Toggle Header Button */}
                        <button
                          type="button"
                          onClick={() => setShowBillPaymentDetails(!showBillPaymentDetails)}
                          className="flex items-center justify-between w-full border-b pb-2 group hover:border-theme-color transition-colors"
                        >
                          <div className="flex items-center gap-2">
                            <h3 className={`text-xs font-bold uppercase tracking-wider transition-colors ${showBillPaymentDetails ? 'text-theme-color' : 'text-gray-400'}`}>
                              Invoice to pay
                            </h3>
                            {/* Badge showing count */}
                            {billPaymentDetails?.length > 0 && (
                              <span className="bg-gray-200 text-gray-600 text-[10px] px-2 py-0.5 rounded-full font-bold">
                                {billPaymentDetails.length}
                              </span>
                            )}
                          </div>
                          
                          <div className={`transform transition-transform duration-300 text-gray-400 group-hover:text-theme-color ${showBillPaymentDetails ? "rotate-180" : ""}`}>
                            <ExpandMoreIcon /> 
                          </div>
                        </button>

                        {/* Expandable Content Area */}
                        <AnimatePresence>
                          {showBillPaymentDetails && (
                            <motion.div
                              initial={{ height: 0, opacity: 0 }}
                              animate={{ height: "auto", opacity: 1 }}
                              exit={{ height: 0, opacity: 0 }}
                              transition={{ duration: 0.3, ease: "easeInOut" }}
                              className="overflow-hidden"
                            >
                              <div className="py-5 space-y-5">
                                {/* Add button */}
                                <div className="flex gap-3 w-full justify-start">
                                  {isEditable &&
                                    <button 
                                      type="button"
                                      onClick={openAddBillPaymentDetailForm} 
                                      className="flex items-center gap-2 bg-theme-color text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md active:scale-95"
                                    >
                                      <AddCircleOutlineIcon fontSize="small" /> 
                                      New Invoice
                                    </button>
                                  }
                                </div>

                                {/* List of Bill Payment Detail */}
                                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                                  <CreateTable
                                    tableName={"Bill Payment Detail"}
                                    headers={headersBillPaymentDetail}
                                    accessors={accessorsBillPaymentDetail}
                                    data={billPaymentDetails}
                                    actions={actionsBillPaymentDetail}
                                    currentPage={currentPageBillPaymentDetail}
                                    setCurrentPage={setCurrentPageBillPaymentDetail}
                                    itemsPerPage={10}
                                    totalItems={billPaymentDetails?.length}
                                  />
                                </div>
                              </div>
                            </motion.div>
                          )}
                        </AnimatePresence>

                        {/* Summary when collapsed (Optional) */}
                        {!showBillPaymentDetails && billPaymentDetails?.length > 0 && (
                          <motion.p 
                            // initial={{ opacity: 0 }} 
                            // animate={{ opacity: 1 }} 
                            className="text-[11px] text-gray-400 mt-2 italic"
                          >
                            Click to view {billPaymentDetails.length} line items...
                          </motion.p>
                        )}
                      </div>

                      {/* --- Section 3: Final Summary --- */}
                      <div className="md:col-span-2">
                        <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                          
                          {/* Left Side: Details Breakdown */}
                          <div className="flex gap-4 w-full lg:w-auto">
                            <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                              <AccountBalanceWalletIcon className="text-theme-color" />
                            </div>
                            
                            <div className="flex-1 space-y-3">
                              <div>
                                <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                                  Transaction Summary
                                </p>
                                <p className="text-xs text-gray-500">Breakdown of all line items</p>
                              </div>
                            </div>
                          </div>

                          {/* Right Side: Final Total & Status */}
                          <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                            <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                              Final Amount Paid
                            </p>
                            <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                              <span className="text-4xl font-black text-gray-900 tracking-tight">
                                {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalBillAmount)}`}
                              </span>
                            </div>
                            <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                              <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                                {`Total EWT: ${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalEWT)}`}
                              </p>
                            </div>

                            {/* Visual indicator of validation */}
                            {/* {amount > 0 ? (
                              <span className="inline-flex items-center text-[10px] font-bold text-green-600 bg-green-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-green-100">
                                <span className="mr-1">●</span> Ready to Save
                              </span>
                            ) : (
                              <span className="inline-flex items-center text-[10px] font-bold text-amber-600 bg-amber-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-amber-100">
                                <span className="mr-1">○</span> No amount detected
                              </span>
                            )} */}
                          </div>
                        </div>
                      </div>


                      {/* --- Section 4: Chart of Accounts --- */}
                      <div className="md:col-span-2 mt-10">
                        {/* Toggle Header Button */}
                        <button
                          type="button"
                          onClick={() => setShowChartOfAccounts(!showChartOfAccounts)}
                          className="flex items-center justify-between w-full border-b pb-2 group hover:border-theme-color transition-colors"
                        >
                          <div className="flex items-center gap-2">
                            <h3 className={`text-xs font-bold uppercase tracking-wider transition-colors ${showChartOfAccounts ? 'text-theme-color' : 'text-gray-400'}`}>
                              Chart of Accounts
                            </h3>
                            {/* Badge showing count */}
                            {chartOfAccounts?.length > 0 && (
                              <span className="bg-gray-200 text-gray-600 text-[10px] px-2 py-0.5 rounded-full font-bold">
                                {chartOfAccounts.length}
                              </span>
                            )}
                          </div>
                          
                          <div className={`transform transition-transform duration-300 text-gray-400 group-hover:text-theme-color ${showChartOfAccounts ? "rotate-180" : ""}`}>
                            <ExpandMoreIcon /> 
                          </div>
                        </button>

                        {/* Expandable Content Area */}
                        <AnimatePresence>
                          {showChartOfAccounts && (
                            <motion.div
                              initial={{ height: 0, opacity: 0 }}
                              animate={{ height: "auto", opacity: 1 }}
                              exit={{ height: 0, opacity: 0 }}
                              transition={{ duration: 0.3, ease: "easeInOut" }}
                              className="overflow-hidden"
                            >
                              <div className="py-5 space-y-5">
                                {/* Add button */}
                                <div className="flex gap-3 w-full justify-start">
                                  {isEditable &&
                                    <button 
                                      type="button"
                                      onClick={openAddChartOfAccountForm} 
                                      className="flex items-center gap-2 bg-theme-color text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md active:scale-95"
                                    >
                                      <AddCircleOutlineIcon fontSize="small" /> 
                                      New Account
                                    </button>
                                  }
                                </div>

                                {/* List of Chart Of Accounts */}
                                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                                  <CreateTable
                                    tableName={"Chart Of Accounts Transaction"}
                                    headers={headersChartOfAccount}
                                    accessors={accessorsChartOfAccount}
                                    data={chartOfAccounts}
                                    actions={actionsChartOfAccount}
                                    currentPage={currentPageChartOfAccount}
                                    setCurrentPage={setCurrentPageChartOfAccount}
                                    itemsPerPage={10}
                                    totalItems={chartOfAccounts?.length}
                                  />
                                </div>
                              </div>
                            </motion.div>
                          )}
                        </AnimatePresence>

                        {/* Summary when collapsed (Optional) */}
                        {!showChartOfAccounts && chartOfAccounts?.length > 0 && (
                          <motion.p 
                            // initial={{ opacity: 0 }} 
                            // animate={{ opacity: 1 }} 
                            className="text-[11px] text-gray-400 mt-2 italic"
                          >
                            Click to view {chartOfAccounts.length} line items...
                          </motion.p>
                        )}
                      </div>

                      {/* --- Section 5: Final Summary --- */}
                      <div className="md:col-span-2">
                        <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                          
                          {/* Left Side: Details Breakdown */}
                          <div className="flex gap-4 w-full lg:w-auto">
                            <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                              <AccountBalanceWalletIcon className="text-theme-color" />
                            </div>
                            
                            <div className="flex-1 space-y-3">
                              <div>
                                <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                                  Accounts Summary
                                </p>
                                <p className="text-xs text-gray-500">Breakdown of all accounts</p>
                                <span className="text-[16px] font-bold uppercase tracking-widest text-gray-400">
                                  {`To Pay: ${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalBillAmount)}`}
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* Right Side: Final Total & Status */}
                          <div className="bg-white rounded-2xl flex flex-col justify-between items-start lg:items-center gap-2">
                            <div className="bg-white flex flex-col lg:flex-row justify-between items-start lg:items-center gap-10">
                              <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                                <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                                  DEBIT AMOUNT
                                </p>
                                <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                                  <span className="text-4xl font-black text-gray-900 tracking-tight">
                                    {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalDebitChartOfAccountAmount)}`}
                                  </span>
                                </div>
                              </div>

                              <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                                <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                                  CREDIT AMOUNT
                                </p>
                                <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                                  <span className="text-4xl font-black text-gray-900 tracking-tight">
                                    {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalCreditChartOfAccountAmount)}`}
                                  </span>
                                </div>
                              </div>
                            </div>
                            {/* Visual indicator of validation */}
                            {/* {totalDebitChartOfAccountAmount === totalCreditChartOfAccountAmount && totalDebitChartOfAccountAmount === totalBillAmount ? (
                              <span className="inline-flex items-center text-[10px] font-bold text-green-600 bg-green-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-green-100">
                                <span className="mr-1">●</span> Ready to Save
                              </span>
                            ) : ( 
                              <span className="inline-flex items-center text-[10px] font-bold text-red-600 bg-red-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-red-100">
                                <span className="mr-1">○</span> Not tally
                              </span>
                            )} */}
                            {totalDebitChartOfAccountAmount === totalCreditChartOfAccountAmount && totalBillAmount > 0 && totalDebitChartOfAccountAmount === totalBillAmount && (
                              <span className="inline-flex items-center text-[10px] font-bold text-green-600 bg-green-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-green-100">
                                <span className="mr-1">●</span> Ready to Save
                              </span>
                            )}
                            {totalDebitChartOfAccountAmount !== totalCreditChartOfAccountAmount && totalBillAmount > 0 && ( 
                              <span className="inline-flex items-center text-[10px] font-bold text-red-600 bg-red-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-red-100">
                                <span className="mr-1">○</span> Not tally
                              </span>
                            )}
                            {totalDebitChartOfAccountAmount === totalCreditChartOfAccountAmount && totalBillAmount > totalDebitChartOfAccountAmount && ( 
                              <span className="inline-flex items-center text-[10px] font-bold text-red-600 bg-red-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-red-100">
                                <span className="mr-1">○</span> {`Not enough to pay ${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalBillAmount)}`}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">
                          Payment Method <span className="text-red-500">*</span>
                        </label>
                        <PaymentMethodSelect2 data={paymentMethod} setData={setPaymentMethod} bank={bank} setBank={setBank} 
                          referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
                          isEditable={true} 
                        />
                      </div>
                      
                      {paymentMethod?.id === CHECK_PAYMENT_METHOD && 
                        <>
                          <div>
                            <label className="block text-sm font-semibold mb-1 text-gray-700">
                              Bank <span className="text-red-500">*</span>
                            </label>
                            <div className="flex flex-row items-center">
                              <input
                                type="text"
                                placeholder="Select Bank"
                                className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                                value={bank?.bankName || ""}
                                readOnly
                              />
                              {!bank ?
                                <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openBankSelectForm}>
                                  <ManageSearchIcon className="text-white"/>
                                </button> 
                                :
                                <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setBank(null)}>
                                  <RemoveCircleIcon className="text-white"/>
                                </button>
                              }
                            </div>
                          </div>
                          <div>
                            <label className="block text-sm font-semibold mb-1 text-gray-700">
                              Checkbook <span className="text-red-500">*</span>
                            </label>
                            { billPaymentHeader != null ?
                              <CheckbookFromUpdateSelect oldData={billPaymentHeader} data={checkbook} setData={setCheckbook} bank={bank} 
                                referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
                                isEditable={true} 
                              />
                              :
                              <CheckbookSelect data={checkbook} setData={setCheckbook} bank={bank} 
                                referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
                                isEditable={true} 
                              />
                            }
                          </div>
                        </>
                      }

                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">
                          Reference No <span className="text-red-500">*</span>
                        </label>
                        <input
                          placeholder="0000-0000"
                          className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={referenceNumber}
                          onChange={(e) => setReferenceNumber(e.target.value)}
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">Amount</label>
                        <input
                          type="number"
                          placeholder="0.00"
                          className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                        />
                        <div className="text-xs text-gray-500 flex items-center gap-1">
                          <span className="font-semibold text-gray-400 italic">
                            {getCurrency?.symbol ?? ""}
                            {FormatValueToDecimal(amount || 0)}
                          </span>
                        </div>
                      </div>
                      
                      <div className="hidden">
                        <div>
                          <label className="block text-sm font-semibold mb-1 text-gray-700">
                            Paid Through Account <span className="text-red-500">*</span>
                          </label>
                          <div className="flex flex-row items-center">
                            <input
                              type="text"
                              placeholder="Select Account"
                              className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                              value={paidThroughAccount?.accountName || ""}
                              readOnly
                            />
                            {!paidThroughAccount ? (
                              <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openPaidThroughAccountSelectForm}>
                                <ManageSearchIcon className="text-white" />
                              </button>
                            ) : (
                              <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={() => setPaidThroughAccount(null)}>
                                <RemoveCircleIcon className="text-white" />
                              </button>
                            )}
                          </div>
                        </div>

                        <div>
                          <label className="block text-sm font-semibold mb-1 text-gray-700">Amount</label>
                          <input
                            type="number"
                            placeholder="0.00"
                            className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                          />
                          <div className="text-xs text-gray-500 flex items-center gap-1">
                            <span className="font-semibold text-gray-400 italic">
                              {getCurrency?.symbol ?? ""}
                              {FormatValueToDecimal(amount || 0)}
                            </span>
                          </div>
                        </div>

                        <div>
                          <label className="block text-sm font-semibold mb-1 text-gray-700">Payment Method</label>
                          <PaymentMethodSelect data={paymentMethod} setData={setPaymentMethod} isEditable={true} />
                        </div>

                        <div>
                          <label className="block text-sm font-semibold mb-1 text-gray-700">Reference #</label>
                          <input
                            placeholder="0000-0000"
                            className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                            value={referenceNumber}
                            onChange={(e) => setReferenceNumber(e.target.value)}
                          />
                        </div>
                      </div>

                      {/* Full Width: Notes */}
                      <div className="md:col-span-2">
                        <label className="block text-sm font-semibold mb-1 text-gray-700">Notes</label>
                        <textarea
                          rows="3"
                          placeholder="Enter any additional details or remarks..."
                          className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={notes}
                          onChange={(e) => setNotes(e.target.value)}
                          readOnly={!isEditable}
                        />
                      </div>
                    </div>

                    <div className="mt-6 space-y-2">
                      <label className="text-[11px] font-bold uppercase tracking-widest text-gray-400 ml-1">Attachment</label>
                      
                      <div className={`relative group transition-all duration-200 rounded-xl border-2 border-dashed 
                        ${uploadedFile ? 'border-theme-color/30 bg-theme-color/5' : 'border-gray-200 hover:border-theme-color/50 bg-gray-50/50 hover:bg-white'}`}>
                        
                        {/* Hidden Input - clickable over the whole area */}
                        {isEditable && (
                          <input
                            type="file"
                            onChange={handleFileChange}
                            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                          />
                        )}
      
                        <div className="p-4 flex items-center justify-between gap-4">
                          <div className="flex items-center gap-3">
                            {/* Icon based on state */}
                            <div className={`p-2.5 rounded-lg ${uploadedFile ? 'bg-theme-color text-white' : 'bg-gray-200 text-gray-500'}`}>
                              {uploadedFile ? (
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                              ) : (
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                </svg>
                              )}
                            </div>
      
                            <div>
                              <p className={`text-sm font-semibold truncate max-w-[200px] ${uploadedFile ? 'text-gray-800' : 'text-gray-500'}`}>
                                {uploadedFile ? uploadedFile.fileName : "Click to upload file"}
                              </p>
                              <p className="text-[11px] text-gray-400 font-medium">
                                {uploadedFile ? (uploadedFile.contentType || "Document") : "Support any file format"}
                              </p>
                            </div>
                          </div>
      
                          {/* Action Button */}
                          {uploadedFile && (
                            <button
                              type="button"
                              onClick={(e) => { e.stopPropagation(); DownloadFile(uploadedFile); }}
                              className="relative z-20 flex items-center gap-2 px-4 py-2 text-xs font-bold text-theme-color bg-white border border-theme-color/20 rounded-lg shadow-sm hover:bg-theme-color hover:text-white transition-all"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                              </svg>
                              DOWNLOAD
                            </button>
                          )}
                        </div>
                      </div>
                      
                      {!uploadedFile && <p className="text-[10px] text-gray-400 italic ml-1">* No file attached yet</p>}
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Save Transaction
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
      
      <VendorSelect 
        visible={showVendorSelectForm} 
        onClose={closeVendorSelectForm}
        modalName={"Select Vendor"}
        data={vendor} setData={setVendor}
      />
            
      <BankChartOfAccountsSelect 
        visible={showPaidThroughAccountSelectForm} 
        onClose={closePaidThroughAccountSelectForm}
        modalName={"Select Account"}
        data={paidThroughAccount} setData={setPaidThroughAccount}
      />

      <AddUpdateBillPaymentDetailsModal 
        visible={showAddBillPaymentDetailForm} 
        onClose={closeAddBillPaymentDetailForm}
        modalName={"Add Invoice"}
        parentModalName={modalName}
        data={selectedBillPaymentDetail}
        billPaymentHeader={billPaymentHeader}
        billPaymentDetails={billPaymentDetails} setBillPaymentDetails={setBillPaymentDetails}
        vendor={vendor}
        isEditable={true}
      />

      <AddUpdateBillPaymentDetailsModal 
        visible={showUpdateBillPaymentDetailForm} 
        onClose={closeUpdateBillPaymentDetailForm}
        modalName={"Update Invoice"}
        parentModalName={modalName}
        data={selectedBillPaymentDetail}
        billPaymentHeader={billPaymentHeader}
        billPaymentDetails={billPaymentDetails} setBillPaymentDetails={setBillPaymentDetails}
        vendor={vendor}
        isEditable={true}
      />

      <AddUpdateBillPaymentDetailsModal 
        visible={showViewBillPaymentDetailForm} 
        onClose={closeViewBillPaymentDetailForm}
        modalName={"View Invoice"}
        parentModalName={modalName}
        data={selectedBillPaymentDetail}
        billPaymentHeader={billPaymentHeader}
        billPaymentDetails={billPaymentDetails} setBillPaymentDetails={setBillPaymentDetails}
        vendor={vendor}
        isEditable={false}
      />

      <AddUpdateChartOfAccountsModal 
        visible={showAddChartOfAccountForm} 
        onClose={closeAddChartOfAccountForm}
        modalName={"Add Account"}
        parentModalName={modalName}
        data={selectedChartOfAccount}
        chartOfAccounts={chartOfAccounts} setChartOfAccounts={setChartOfAccounts}
        billPaymentDetails={billPaymentDetails} setBillPaymentDetails={setBillPaymentDetails}
        // customer={customer}
        isEditable={true}
      />

      <AddUpdateChartOfAccountsModal 
        visible={showUpdateChartOfAccountForm} 
        onClose={closeUpdateChartOfAccountForm}
        modalName={"Update Account"}
        parentModalName={modalName}
        data={selectedChartOfAccount}
        chartOfAccounts={chartOfAccounts} setChartOfAccounts={setChartOfAccounts}
        billPaymentDetails={billPaymentDetails} setBillPaymentDetails={setBillPaymentDetails}
        // customer={customer}
        isEditable={true}
      />

      <AddUpdateChartOfAccountsModal 
        visible={showViewChartOfAccountForm} 
        onClose={closeViewChartOfAccountForm}
        modalName={"View Account"}
        parentModalName={modalName}
        data={selectedChartOfAccount}
        chartOfAccounts={chartOfAccounts} setChartOfAccounts={setChartOfAccounts}
        billPaymentDetails={billPaymentDetails} setBillPaymentDetails={setBillPaymentDetails}
        // customer={customer}
        isEditable={false}
      />
      
      <ConfirmationModal 
        visible={showDeleteBillPaymentDetailForm} 
        onClose={closeDeleteBillPaymentDetailForm} 
        onSave={handleDeleteBillPaymentDetail} 
        modalName={"Delete"} 
        message={`Do you want to remove this account [ ${selectedBillPaymentDetail?.billNumber} ]?.`}
      />

      <ConfirmationModal 
        visible={showDeleteChartOfAccountForm} 
        onClose={closeDeleteChartOfAccountForm} 
        onSave={handleDeleteChartOfAccount} 
        modalName={"Delete"} 
        message={`Do you want to remove this account [ ${selectedChartOfAccount?.glAccountName} ]?.`}
      />

      <BankSelect
        visible={showBankSelectForm}
        onClose={closeBankSelectForm}
        modalName={"Select Bank"}
        data={bank} // full current data array
        setData={setBank}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
      
      { loading && <Loading />}
    </>
  );
};
const ViewModal = ({
  visible, onClose, onSave, modalName,
  billPaymentHeader,
  billPaymentDetails, setBillPaymentDetails,
  vendor, setVendor,
  paymentNumber, setPaymentNumber,
  paidThroughAccount, setPaidThroughAccount,
  amount, setAmount,
  paymentDate, setPaymentDate,
  paymentMethod, setPaymentMethod,
  referenceNumber, setReferenceNumber,
  notes, setNotes,
  uploadedFile, setUploadedFile,
  isEditable
}) => {
  
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const printRef = useRef();
  const [isDownloading, setIsDownloading] = useState(false);

  // Helper for currency formatting
  const formatVal = (num) => {
    return typeof FormatValueToDecimal === "function" 
      ? FormatValueToDecimal(num) 
      : Number(num || 0).toLocaleString(undefined, { minimumFractionDigits: 2 });
  };

  const downloadHandleClick = async () => {
    const element = printRef.current;
    if (!element) return;

    setIsDownloading(true);
    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        windowWidth: 1200,
        windowHeight: element.scrollHeight
      });

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });

      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      pdf.save(`Payment_${'Export'}.pdf`);
    } catch (error) {
      console.error("PDF Generation Error:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleSubmit = async () => {
    await downloadHandleClick();
  };

  const closeModal = () => {
    onClose();
  };

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar bg-gray-100">
              <div
                ref={printRef}
                className="max-w-4xl mx-auto bg-white shadow-xl border border-gray-200 rounded-sm p-12 min-h-[800px] flex flex-col"
              >
                {/* 1. TOP HEADER */}
                <div className="flex justify-between items-start border-b-4 border-theme-color pb-8 mb-10">
                  <div>
                    <h1 className="text-4xl font-black text-theme-color tracking-tighter mb-2">PAYMENT VOUCHER</h1>
                    <div className="flex items-center gap-4">
                      <div className="flex flex-col">
                        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Payment Method</span>
                        <span className="text-sm font-bold text-gray-700">{paymentMethod?.description || "N/A"}</span>
                      </div>
                      <div className="h-8 w-[1px] bg-gray-200 mx-2"></div>
                      <div className="flex flex-col">
                        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Reference #</span>
                        <span className="text-sm font-bold text-gray-700">{referenceNumber || "---"}</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Voucher Number</p>
                    <p className="text-2xl font-mono font-bold text-gray-900">#{paymentNumber || 'DRAFT'}</p>
                    <p className="mt-4 text-[10px] font-bold text-gray-400 uppercase tracking-widest">Payment Date</p>
                    <p className="text-sm font-bold text-gray-800">{paymentDate ? new Date(paymentDate).toLocaleDateString('en-US', { dateStyle: 'long' }) : 'N/A'}</p>
                  </div>
                </div>

                {/* 2. PAYMENT SOURCE & DESTINATION GRID */}
                <div className="grid grid-cols-2 gap-0 mb-12 border border-gray-100 rounded-2xl overflow-hidden shadow-sm">
                  {/* From: Account */}
                  <div className="p-6 bg-gray-50 border-r border-gray-100">
                    <h3 className="text-[10px] font-black text-theme-color uppercase tracking-[0.2em] mb-4">Paid From (Source)</h3>
                    <div className="flex items-center gap-4">
                      <div className="bg-theme-color text-white p-3 rounded-lg">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                        </svg>
                      </div>
                      <div>
                        <p className="font-bold text-gray-900 text-lg leading-tight">{paidThroughAccount?.accountName || "Bank/Cash Account"}</p>
                      </div>
                    </div>
                  </div>

                  {/* To: Vendor */}
                  <div className="p-6 bg-white">
                    <h3 className="text-[10px] font-black text-theme-color uppercase tracking-[0.2em] mb-4">Paid To (Payee)</h3>
                    <div>
                      <p className="font-bold text-gray-900 text-lg leading-tight">{vendor?.name1 || vendor?.Name1 || "N/A"}</p>
                      <p className="text-sm text-gray-500">{vendor?.name2 || vendor?.Name2}</p>
                      <p className="text-xs text-gray-400 mt-1 font-mono">Vendor ID: {vendor?.vendorId || vendor?.VendorId}</p>
                    </div>
                  </div>
                </div>

                {/* 3. BILLS SETTLED TABLE */}
                <div className="flex-grow">
                  <div className="mb-4">
                    <h3 className="text-[11px] font-bold text-gray-900 uppercase tracking-widest flex items-center gap-2">
                      Settlement Details
                      <span className="h-[1px] flex-1 bg-gray-100"></span>
                    </h3>
                  </div>
                  <table className="w-full">
                    <thead>
                      <tr className="border-b-2 border-gray-900">
                        <th className="py-3 text-left text-[10px] font-bold uppercase tracking-widest text-gray-400">Bill Number</th>
                        <th className="py-3 text-left text-[10px] font-bold uppercase tracking-widest text-gray-400">Due Date</th>
                        <th className="py-3 text-right text-[10px] font-bold uppercase tracking-widest text-gray-400">Original Due</th>
                        <th className="py-3 text-right text-[10px] font-bold uppercase tracking-widest text-gray-900">Amount Paid</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                      {billPaymentDetails?.length > 0 ? (
                        billPaymentDetails.map((detail, idx) => (
                          <tr key={idx} className="hover:bg-gray-50/50">
                            <td className="py-4">
                              <p className="text-sm font-bold text-gray-800">{detail.bill?.billNumber || detail.BillNumber || '---'}</p>
                              <p className="text-[10px] text-gray-400 italic">Ref: {detail.bill?.orderNumber || detail.OrderNumber || 'N/A'}</p>
                            </td>
                            <td className="py-4 text-sm text-gray-600">
                              {detail.bill?.dueDate ? new Date(detail.bill.dueDate).toLocaleDateString() : 'N/A'}
                            </td>
                            <td className="py-4 text-right text-sm font-medium text-gray-400">
                              {getCurrency?.symbol} {formatVal(detail.amountDueBeforePayment)}
                            </td>
                            <td className="py-4 text-right text-sm font-bold text-gray-900">
                              {getCurrency?.symbol} {formatVal(detail.amountPaid)}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="py-10 text-center text-sm text-gray-400 italic">No bill details associated with this payment</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* 4. TOTALS & FOOTER */}
                <div className="mt-10 pt-10 border-t-2 border-gray-900">
                  <div className="flex justify-between items-start">
                    <div className="max-w-md">
                      <h4 className="text-[10px] font-black text-gray-900 uppercase tracking-widest mb-2">Remarks / Notes</h4>
                      <p className="text-xs text-gray-500 leading-relaxed italic border-l-4 border-theme-color pl-4">
                        {notes || "No additional payment remarks."}
                      </p>
                    </div>

                    <div className=" text-gray-800 p-8 text-right min-w-[280px]">
                      <p className="text-[10px] font-bold uppercase tracking-[0.2em] mb-1 opacity-80">Total Amount Paid</p>
                      <p className="text-4xl font-black">
                        {getCurrency?.symbol} {formatVal(amount)}
                      </p>
                      <div className="mt-4 pt-4 border-t border-white/20">
                        <p className="text-[9px] italic opacity-70">Amount in words available upon request</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                disabled={isDownloading}
                className={`px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm flex items-center gap-2 ${isDownloading ? 'opacity-70 cursor-not-allowed' : 'hover:opacity-90'}`}
              >
                {isDownloading ? (
                    <>
                      <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                      Generating PDF...
                    </>
                ) : 'Download PDF'}
              </button>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
    </>
  );
};
//#endregion














//#region Bill Payment Details
const AddUpdateBillPaymentDetailsModal = ({
  visible, onClose, onSave, modalName, parentModalName,
  data, billPaymentHeader,
  billPaymentDetails, setBillPaymentDetails,
  isEditable,
  vendor
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");

  const [failMessage, setFailMessage] = useState("");
  const [bill, setBill] = useState(null);
  const [amountPaid, setAmountPaid] = useState(0);
  const [vatableAmount, setVatableAmount] = useState(0);
  const [vat, setVat] = useState(0);
  const [ewt, setEWT] = useState(0);
  const [taxationCode, setTaxationCode] = useState(null);

  useEffect(() => {
    if(bill){
      const foundDetail = billPaymentDetails.find(i => i.billId === bill?.id)

      setTaxationCode(foundDetail?.taxationCode ?? null)
    }
  }, [billPaymentDetails, bill])

  const [showBillSelectForm, setShowBillSelectForm] = useState(false);
  const openBillSelectForm = () => {
    setShowBillSelectForm(true);
  }
  const closeBillSelectForm = () => {
    setShowBillSelectForm(false);
  }

  const handleSubmit = async () => {
    // Logic updated to match your state requirements
    if (!bill) {
      setFailMessage("Please fill up all required fields (Invoice, Paid Through, and Amount).");
      return;
    }

    if(modalName === "Add Invoice"){
      const foundData = billPaymentDetails.find(i => i.billId === bill.id)

      if (foundData) {
        setFailMessage("Already added this account.");
        return;
      }

      const newData = {
        billId: bill?.id,
        bill: bill,
        billNumber: bill?.billNumber,
        orderNumber: bill?.orderNumber,
        dueDate: bill?.dueDate,
        totalAmount: bill?.totalAmount,
        amountDue: bill?.amountDue,
        amountDueBeforePayment: bill?.amountDue,
        amountPaid: Number(amountPaid),
        taxationCodeId: taxationCode?.id,
        taxationCode: taxationCode,
        ewt: ewt,
      }

      setBillPaymentDetails((prev) => [...prev, newData])
    }

    if(modalName === "Update Invoice"){
      const foundData = billPaymentDetails.find(i => i.billId === bill.id && data?.billId !== bill.id)

      if (foundData) {
        setFailMessage("Already added this account.");
        return;
      }

      const newData = {
        billId: bill?.id,
        bill: bill,
        billNumber: bill?.billNumber,
        orderNumber: bill?.orderNumber,
        dueDate: bill?.dueDate,
        totalAmount: bill?.totalAmount,
        amountDue: bill?.amountDue,
        amountDueBeforePayment: bill?.amountDue,
        amountPaid: Number(amountPaid),
        taxationCodeId: taxationCode?.id,
        taxationCode: taxationCode,
        ewt: ewt,
      }

      setBillPaymentDetails(prev =>
        prev.map(item =>
          item.billId === data?.billId
            ? newData
            : item
        )
      );
    }

    closeModal();
  };

  const resetLocalVariables = () => {
    setBill(null)
    setAmountPaid(0)
    setVatableAmount(0)
    setVat(0)
    setEWT(0)
    setTaxationCode(null)
  }

  const closeModal = () => {
    setFailMessage("");
    onClose();
    resetLocalVariables();
  };

  useEffect(() => {
    if(visible){
      setBill(data?.bill ?? null)
      setAmountPaid(data?.amountPaid ?? 0)
    }
  }, [visible, data])

  useEffect(() => {
    if (bill) {
      const total = Number(bill?.totalAmount) || 0;
      let amountDue = Number(bill?.amountDue) || 0;

      if(!isEditable){
        amountDue =  Number(bill?.amountPaid) || 0;
      }

      // const ewtRate = Number(bill?.ewtRate || 0.01); // Defaulting to 1% (0.01) if not provided

      let vatable = 0;
      let vatValue = 0;
      // let ewtValue = 0;

      // 1. VAT Calculations
      if (bill?.vendorPriceType === "Inclusive") {
        // Formula: Total / 1.12
        vatable = total / 1.12;
        vatValue = total - vatable;
      } else {
        // Formula: Total is the vatable amount, VAT is added on top
        vatable = total;
      }

      // 2. EWT Calculation (Calculated based on Vatable Amount)
      /* if (bill?.vendorIsEWT) {
        ewtValue = vatable * ewtRate;
      } */

      // 3. Update States
      setAmountPaid(amountDue); // Sets default payment input to the remaining balance
      setVatableAmount(vatable);
      setVat(vatValue);
      // setEWT(ewtValue);
    }
  }, [bill, isEditable]);

  useEffect(() => {
    if (taxationCode) {
      const ewtRate = Number((taxationCode?.rate ?? 0) / 100);
      let ewtValue = 0;
      
      ewtValue = vatableAmount * ewtRate;
      setEWT(ewtValue);
    }
  }, [taxationCode, vatableAmount]);

  /* useEffect(() => {
    if(bill){
      if(isEditable){
        const _amountDue = bill?.amountDue ?? 0;
        setAmountPaid(_amountDue)
      } else {
        const value = bill?.amountPaid ?? 0;
        setAmountPaid(value)
      }
    }
  }, [bill, isEditable]) */

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-5xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <>
                  {/* --- Section 1: Entities --- */}
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Basic Details</h3>
                  </div>

                  { isEditable ?
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Invoice <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Account"
                          className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={bill?.billNumber || ""}
                          readOnly
                        />
                        {!bill ?
                          <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openBillSelectForm}>
                            <ManageSearchIcon className="text-white"/>
                          </button> 
                          :
                          <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setBill(null)}>
                            <RemoveCircleIcon className="text-white"/>
                          </button>
                        }
                      </div>
                    </div>
                    :
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Invoice <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Account"
                          className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={bill?.billNumber || ""}
                          readOnly
                        />
                      </div>
                    </div>
                  }

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Amount <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-row items-center">
                      <input
                        type="number"
                        className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                        value={amountPaid}
                        onChange={(e) => setAmountPaid(e.target.value)}
                        readOnly={!isEditable}
                      />
                    </div>
                    <div className="text-xs text-gray-500 flex items-center gap-1">
                      <span className="font-semibold text-gray-400 italic">
                        {getCurrency?.symbol ?? ""}
                        {FormatValueToDecimal(amountPaid || 0)}
                      </span>
                    </div>
                  </div>

                  <div className="md:col-span-2">
                    <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-stretch gap-8">
                      <div className="flex gap-5 flex-1">
                        {/* Icon Section */}
                        <div className="hidden sm:block">
                          <div className="bg-slate-50 p-3 rounded-xl border border-slate-100">
                            <AccountBalanceWalletIcon className="text-slate-600" />
                          </div>
                        </div>

                        <div className="flex-1">
                          <div className="mb-4">
                            <h3 className="text-sm font-bold text-gray-900 uppercase tracking-tight">Payment Summary</h3>
                            <p className="text-xs text-gray-500">Breakdown of taxes and collection status</p>
                          </div>

                          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 pt-4 border-t border-gray-100">
                            {/* Group 1: Billing & Taxes */}
                            <div className="space-y-2.5">
                              <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-1">Accounting Details</p>
                              <div className="flex justify-between text-xs">
                                <span className="text-gray-500">Vatable Amount</span>
                                <span className="font-semibold text-gray-700">{getCurrency?.symbol} {FormatValueToDecimal(vatableAmount)}</span>
                              </div>
                              <div className="flex justify-between text-xs">
                                <span className="text-gray-500">VAT (12%)</span>
                                <span className="font-semibold text-gray-700">{getCurrency?.symbol} {FormatValueToDecimal(vat || 0)}</span>
                              </div>

                              <div className="flex justify-between text-xs w-full">
                                <div className="w-full flex flex-col gap-2">
                                  <span className="text-gray-500">Taxation Code</span>
                                  <div className="w-full">
                                    <TaxationCodeSelect data={taxationCode} setData={setTaxationCode} isEditable={true}/>
                                  </div>
                                </div>
                              </div>
                              <div className="flex justify-between text-xs">
                                <span className="text-gray-500">EWT</span>
                                <span className="font-semibold text-orange-600">({getCurrency?.symbol} {FormatValueToDecimal(ewt || 0)})</span>
                              </div>
                            </div>

                            {/* Group 2: Payment Status */}
                            <div className="space-y-2.5 border-t md:border-t-0 md:border-l md:pl-8 border-gray-100 pt-4 md:pt-0">
                              <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-1">Payment Progress</p>
                              <div className="flex justify-between text-xs">
                                <span className="text-gray-500">Total Bill</span>
                                <span className="font-bold text-gray-900">{getCurrency?.symbol} {FormatValueToDecimal(bill?.totalAmount)}</span>
                              </div>
                              <div className="flex justify-between text-xs">
                                <span className="text-gray-500">Amount Paid</span>
                                <span className="font-bold text-red-600">
                                  {getCurrency?.symbol} {FormatValueToDecimal(modalName === "Update Invoice" ? Number(bill?.totalAmount) - Number(bill?.amountDue) : bill?.amountPaid)}
                                </span>
                              </div>
                              <div className="flex justify-between text-xs">
                                <span className="text-gray-500">Balance</span>
                                <span className="font-bold text-red-500">{getCurrency?.symbol} {FormatValueToDecimal(bill?.amountDue)}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Summary Side Card */}
                      <div className="lg:w-64 bg-slate-50 rounded-xl p-5 flex flex-col justify-center items-center lg:items-end border border-slate-100">
                        <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">Total Amount Due</p>
                        <div className="text-3xl font-black text-slate-900 tracking-tight">
                          {getCurrency?.symbol} {FormatValueToDecimal(bill?.amountDue)}
                        </div>
                        <div className={`mt-2 px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase ${bill?.amountDue > 0 ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
                          {bill?.amountDue > 0 ? 'Pending Payment' : 'Fully Paid'}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Save Transaction
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
      
      {parentModalName === "Update Payment" ?
        <BillPerVendorTamperedSelect 
          visible={showBillSelectForm} 
          onClose={closeBillSelectForm}
          modalName={"Select Bills"}
          data={bill} setData={setBill}
          billPaymentHeader={billPaymentHeader}
          vendor={vendor}
        /> 
      :
        <BillPerVendorSelect 
          visible={showBillSelectForm} 
          onClose={closeBillSelectForm}
          modalName={"Select Bills"}
          data={bill} setData={setBill}
          vendor={vendor}
        />
      }

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
const ViewBillPaymentDetailsModal = ({
  visible, onClose, onSave, modalName,
  billPaymentDetails, setBillPaymentDetails,
}) => {
  
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [amount, setAmount] = useState(0);
  const [totalBillAmount, setTotalBillAmount] = useState(0);

  const closeModal = () => {
    onClose();
  };

  const [currentPageBillPaymentDetail, setCurrentPageBillPaymentDetail] = useState(1);

  const [selectedBillPaymentDetail, setSelectedBillPaymentDetail] = useState(null);
  const [showViewBillPaymentDetailForm, setShowViewBillPaymentDetailForm] = useState(false);
  const openViewBillPaymentDetailForm = () => {
    setShowViewBillPaymentDetailForm(true);
  }
  const closeViewBillPaymentDetailForm = () => {
    setShowViewBillPaymentDetailForm(false);
    setSelectedBillPaymentDetail(null)
  }

  const viewHandleBillPaymentDetailClick = (_data) => {
    setSelectedBillPaymentDetail(_data)
    openViewBillPaymentDetailForm();
  }

  const headersBillPaymentDetail = [
    'INVOICE NUMBER', 
    'ORDER NUMBER', 
    'DUE DATE', 
    'TOTAL AMOUNT', 
    'AMOUNT DUE', 
    'AMOUNT PAID', 
    'ACTIONS'
  ]
  const accessorsBillPaymentDetail = [
    'billNumber', 
    'orderNumber', 
    'dueDate', 
    'totalAmount', 
    'amountDueBeforePayment', 
    'amountPaid', 
    'actions'
  ]

  const actionsBillPaymentDetail = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleBillPaymentDetailClick,
      visible: true,
    },
  ];

  useEffect(() => {
    const _amount = billPaymentDetails?.reduce((acc, item) => acc + (Number(item.amountPaid) || 0), 0) || 0;
    setTotalBillAmount(_amount)
  }, [billPaymentDetails, setAmount])

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="py-5 space-y-5">
                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                  <CreateTable
                    tableName={"Bill Payment Detail"}
                    headers={headersBillPaymentDetail}
                    accessors={accessorsBillPaymentDetail}
                    data={billPaymentDetails}
                    actions={actionsBillPaymentDetail}
                    currentPage={currentPageBillPaymentDetail}
                    setCurrentPage={setCurrentPageBillPaymentDetail}
                    itemsPerPage={10}
                    totalItems={billPaymentDetails?.length}
                  />
                </div>

                <div className="md:col-span-2">
                  <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                    
                    {/* Left Side: Details Breakdown */}
                    <div className="flex gap-4 w-full lg:w-auto">
                      <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                        <AccountBalanceWalletIcon className="text-theme-color" />
                      </div>
                      
                      <div className="flex-1 space-y-3">
                        <div>
                          <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                            Transaction Summary
                          </p>
                          <p className="text-xs text-gray-500">Breakdown of all line items</p>
                        </div>
                      </div>
                    </div>

                    {/* Right Side: Final Total & Status */}
                    <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                      <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                        Final Amount Paid
                      </p>
                      <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                        <span className="text-4xl font-black text-gray-900 tracking-tight">
                          {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalBillAmount)}`}
                        </span>
                      </div>

                      {/* Visual indicator of validation */}
                      {amount > 0 ? (
                        <span className="inline-flex items-center text-[10px] font-bold text-green-600 bg-green-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-green-100">
                          <span className="mr-1">●</span> Ready to Save
                        </span>
                      ) : (
                        <span className="inline-flex items-center text-[10px] font-bold text-amber-600 bg-amber-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-amber-100">
                          <span className="mr-1">○</span> No amount detected
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <AddUpdateBillPaymentDetailsModal 
        visible={showViewBillPaymentDetailForm} 
        onClose={closeViewBillPaymentDetailForm}
        modalName={"View Invoice"}
        parentModalName={modalName}
        data={selectedBillPaymentDetail}
        // billPaymentHeader={billPaymentHeader}
        billPaymentDetails={billPaymentDetails} setBillPaymentDetails={setBillPaymentDetails}
        // vendor={vendor}
        isEditable={false}
      />
    </>
  );
};
//#endregion








//#region Chart of Accounts
const AddUpdateChartOfAccountsModal = ({
  visible, onClose, onSave, modalName, parentModalName,
  data,
  isEditable,
  chartOfAccounts, setChartOfAccounts,
  billPaymentDetails, setBillPaymentDetails,
  customer
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");

  const [failMessage, setFailMessage] = useState("");
  const [glAccount, setGLAccount] = useState(null);
  const [debitCredit, setDebitCredit] = useState("Debit");
  const [amount, setAmount] = useState(0);
  const [totalBillAmount, setTotalBillAmount] = useState(0);


  const [showGLAccountSelectForm, setShowGLAccountSelectForm] = useState(false);
  const openGLAccountSelectForm = () => {
    setShowGLAccountSelectForm(true);
  }
  const closeGLAccountSelectForm = () => {
    setShowGLAccountSelectForm(false);
  }

  const handleSubmit = async () => {
    // Logic updated to match your state requirements
    if (!glAccount || !debitCredit ) {
      setFailMessage("Please fill up all required fields.");
      return;
    }

    if(modalName === "Add Account"){
      const foundData = chartOfAccounts.find(i => i.glAccountId === glAccount.id)

      if (foundData) {
        setFailMessage("Already added this account.");
        return;
      }

      const newData = {
        glAccountId: glAccount?.id,
        glAccount: glAccount,
        glAccountName: glAccount?.accountName,
        debitCredit: debitCredit,
        amount: Number(amount),
      }

      setChartOfAccounts((prev) => [...prev, newData])
    }

    if(modalName === "Update Account"){
      const foundData = chartOfAccounts.find(i => i.glAccountId === glAccount.id && data?.glAccountId !== glAccount.id)

      if (foundData) {
        setFailMessage("Already added this account.");
        return;
      }

      const newData = {
        glAccountId: glAccount?.id,
        glAccount: glAccount,
        glAccountName: glAccount?.accountName,
        debitCredit: debitCredit,
        amount: Number(amount),
      }

      setChartOfAccounts(prev =>
        prev.map(item =>
          item.glAccountId === data?.glAccountId
            ? newData
            : item
        )
      );
    }

    closeModal();
  };

  const resetLocalVariables = () => {
    setGLAccount(null)
    setDebitCredit("Debit")
    setAmount(0)
  }

  const closeModal = () => {
    setFailMessage("");
    onClose();
    resetLocalVariables();
  };

  useEffect(() => {
    if(visible && data){
      setGLAccount(data?.glAccount)
      setDebitCredit(data?.debitCredit)
      setAmount(data?.amount)
    }
  }, [visible, data])

  useEffect(() => {
    const _amount = billPaymentDetails?.reduce((acc, item) => acc + (Number(item.amountPaid) || 0), 0) || 0;
    setTotalBillAmount(_amount)
  }, [billPaymentDetails, setTotalBillAmount])

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-5xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <>
                  {/* --- Section 1: Entities --- */}
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Basic Details</h3>
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 pb-1">{`To Pay: ${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalBillAmount)}`}</h3>
                  </div>
                  {isEditable ?
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Account <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Account"
                          className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={glAccount?.accountName || ""}
                          readOnly
                        />
                        {!glAccount ?
                          <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openGLAccountSelectForm}>
                            <ManageSearchIcon className="text-white"/>
                          </button> 
                          :
                          <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setGLAccount(null)}>
                            <RemoveCircleIcon className="text-white"/>
                          </button>
                        }
                      </div>
                    </div>
                    :
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Account <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Account"
                          className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={glAccount?.accountName || ""}
                          readOnly
                        />
                      </div>
                    </div>
                  }

                  <div>
                    <label className="block text-sm font-medium mb-1 text-gray-700 ">
                      Debit / Credit <span className="text-red-500">*</span>
                    </label>
                    <DebitCreditSelect data={debitCredit} setData={setDebitCredit} isEditable={isEditable}/>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Amount <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-row items-center">
                      <input
                        type="number"
                        className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        readOnly={!isEditable}
                      />
                    </div>
                    <div className="text-xs text-gray-500 flex items-center gap-1">
                      <span className="font-semibold text-gray-400 italic">
                        {getCurrency?.symbol ?? ""}
                        {FormatValueToDecimal(amount || 0)}
                      </span>
                    </div>
                  </div>
                </>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Save Transaction
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <ChartOfAccountsSelect
        visible={showGLAccountSelectForm}
        onClose={closeGLAccountSelectForm}
        modalName={"Select Account"}
        data={glAccount} // full current data array
        setData={setGLAccount}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
const ViewChartOfAccountsModal = ({
  visible, onClose, onSave, modalName,
  chartOfAccounts, setChartOfAccounts,
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  // const [amount, setAmount] = useState(0);
  const [totalDebitChartOfAccountAmount, setTotalDebitChartOfAccountAmount] = useState(0);
  const [totalCreditChartOfAccountAmount, setTotalCreditChartOfAccountAmount] = useState(0);

  const closeModal = () => {
    onClose();
  };

  const [selectedChartOfAccount, setSelectedChartOfAccount] = useState(null);
  const [currentPageChartOfAccount, setCurrentPageChartOfAccount] = useState(1);

  const headersChartOfAccount = [
    'ACCOUNT', 
    'DEBIT', 
    'CREDIT', 
    'ACTIONS'
  ]
  const accessorsChartOfAccount = [
    'glAccountName', 
    'debit', 
    'credit', 
    'actions'
  ]

  const [showViewChartOfAccountForm, setShowViewChartOfAccountForm] = useState(false);
  const openViewChartOfAccountForm = () => {
    setShowViewChartOfAccountForm(true);
  }
  const closeViewChartOfAccountForm = () => {
    setShowViewChartOfAccountForm(false);
    setSelectedChartOfAccount(null)
  }

  const viewHandleChartOfAccountClick = (_data) => {
    setSelectedChartOfAccount(_data)
    openViewChartOfAccountForm();
  }

  const actionsChartOfAccount = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleChartOfAccountClick,
      visible: true,
    },
  ];

  useEffect(() => {
    const _amount = chartOfAccounts?.filter(i => i.debitCredit === "Debit").reduce((acc, item) => acc + (Number(item.amount) || 0), 0) || 0;
    setTotalDebitChartOfAccountAmount(_amount)
  }, [chartOfAccounts, setTotalDebitChartOfAccountAmount])

  useEffect(() => {
    const _amount = chartOfAccounts?.filter(i => i.debitCredit === "Credit").reduce((acc, item) => acc + (Number(item.amount) || 0), 0) || 0;
    setTotalCreditChartOfAccountAmount(_amount)
  }, [chartOfAccounts, setTotalCreditChartOfAccountAmount])

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="py-5 space-y-5">
                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                  <CreateTable
                    tableName={"Chart Of Accounts Transaction"}
                    headers={headersChartOfAccount}
                    accessors={accessorsChartOfAccount}
                    data={chartOfAccounts}
                    actions={actionsChartOfAccount}
                    currentPage={currentPageChartOfAccount}
                    setCurrentPage={setCurrentPageChartOfAccount}
                    itemsPerPage={10}
                    totalItems={chartOfAccounts?.length}
                  />
                </div>

                <div className="md:col-span-2">
                  <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                    
                    {/* Left Side: Details Breakdown */}
                    <div className="flex gap-4 w-full lg:w-auto">
                      <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                        <AccountBalanceWalletIcon className="text-theme-color" />
                      </div>
                      
                      <div className="flex-1 space-y-3">
                        <div>
                          <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                            Accounts Summary
                          </p>
                          <p className="text-xs text-gray-500">Breakdown of all accounts</p>
                          <span className="text-[16px] font-bold uppercase tracking-widest text-gray-400">
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Right Side: Final Total & Status */}
                    <div className="bg-white rounded-2xl flex flex-col justify-between items-start lg:items-center gap-2">
                      <div className="bg-white flex flex-col lg:flex-row justify-between items-start lg:items-center gap-10">
                        <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                          <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                            DEBIT AMOUNT
                          </p>
                          <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                            <span className="text-4xl font-black text-gray-900 tracking-tight">
                              {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalDebitChartOfAccountAmount)}`}
                            </span>
                          </div>
                        </div>

                        <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                          <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                            CREDIT AMOUNT
                          </p>
                          <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                            <span className="text-4xl font-black text-gray-900 tracking-tight">
                              {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalCreditChartOfAccountAmount)}`}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <AddUpdateChartOfAccountsModal 
        visible={showViewChartOfAccountForm} 
        onClose={closeViewChartOfAccountForm}
        modalName={"View Account"}
        parentModalName={modalName}
        data={selectedChartOfAccount}
        chartOfAccounts={chartOfAccounts} setChartOfAccounts={setChartOfAccounts}
        // customer={customer}
        isEditable={false}
      />
    </>
  );
};
//#endregion









//#region Journal
const CreateJournalModal = ({
  visible, onClose, onSave, modalName,
  data, fetchData,
  isEditable,
}) => {
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [loading, setLoading] = useState(false)
  const [journalLines, setJournalLines] = useState([])
  const [documentNumber, setDocumentNumber] = useState("") 
  const [vendor, setVendor] = useState(null) 
  const [customer, setCustomer] = useState(null)
  const [documentType, setDocumentType] = useState(null)
  const [documentDate, setDocumentDate] = useState(null)
  const today = new Date().toISOString().split("T")[0];
  const [postingDate, setPostingDate] = useState(today)
  const [fiscalYear, setFiscalYear] = useState("")
  const [fiscalPeriod, setFiscalPeriod] = useState("")
  const [currency, setCurrency] = useState("PHP")
  const [referenceNumber, setReferenceNumber] = useState("")
  const [documentHeaderText, setDocumentHeaderText] = useState("")

  const generateNumber = useCallback(async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/Journal/generate-number` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return ""
    }
  }, []);

  const generateJournalLines = useCallback(async () => {
    const _data = {
      description: data?.paymentNumber ?? "",
      key: "payment",
      type: "Payables",
      debitCredit: "Credit",
      mainAccountId: data?.paidThroughAccountId ?? null,
      journalLines: data?.billPaymentDetails?.map(item => {
        return {
          glAccountId: item?.bill?.accountId ?? null,
          referenceNumber: item?.billNumber ?? null,
          amount: item?.amountPaid ?? null,
        }}),
      amount: data?.amount ?? 0,
    }
    try {
      const response = await axios.post(`${apiUrl}/api/Journal/auto-journal-line` , _data, {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return ""
    }
  }, [data]);

  const fetchNumber = useCallback(async () => {
    setLoading(true)

    const _number = await generateNumber();
    setDocumentNumber(_number?.number)

    const _journalLines = await generateJournalLines();
    setJournalLines(_journalLines)

    setLoading(false)
  }, [generateNumber, generateJournalLines])

  const accountData = JSON.parse(localStorage.getItem("accountData"));

  useEffect(() => {
    if (visible && !documentNumber) {
      fetchNumber()
      setVendor(data?.vendor ?? null)
      setCustomer(data?.customer ?? null)

      const _documentType = {
        id: 1,
        description: "Accounts Payable",
        isActive: true
      }

      setDocumentType(_documentType)
      setDocumentDate(data?.documentDate)
      setReferenceNumber(data?.documentNumber)
    }
  }, [visible, documentNumber, fetchNumber, data])

  const handleAddData = async () => {
    const data = {
      journalLines: journalLines,
      vendorId: vendor?.vendorId,
      customerId: customer?.customerId,
      documentSubType: "Payment",
      documentNumber: documentNumber,
      documentTypeId: documentType?.id,
      documentDate: documentDate,
      postingDate: postingDate,
      fiscalYear: fiscalYear,
      fiscalPeriod: fiscalPeriod,
      currency: currency,
      referenceNumber: referenceNumber,
      documentHeaderText: documentHeaderText,
      createdDate: new Date(),
      createdBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/Journal`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 

  const handleSubmit = async () => {
    if(!documentNumber
      || !documentType
      || !postingDate
      || !currency
      || journalLines.length <= 0
    ){
      setFailMessage("Please fill up all required fields.")
      return;
    }

    await handleAddData();
    closeModal();
  };

  const resetLocalVariables = () => {
    setJournalLines([])
    setDocumentNumber("")
    setVendor(null)
    setCustomer(null)
    setDocumentType(null)
    setDocumentDate(null)
    setPostingDate(today)
    setFiscalYear("")
    setFiscalPeriod("")
    setCurrency("PHP")
    setReferenceNumber("")
    setDocumentHeaderText("")
  }

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  }

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{`${modalName}`}</h2>
                <p className="text-sm text-gray-500">{`Document Number: ${documentNumber}`}</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <JournalHeader 
                type={"AP"}
                isEditable={true}
                documentNumber={documentNumber} setDocumentNumber={setDocumentNumber}
                journalLines={journalLines} setJournalLines={setJournalLines}
                vendor={vendor} setVendor={setVendor}
                customer={customer} setCustomer={setCustomer}
                documentType={documentType} setDocumentType={setDocumentType}
                documentDate={documentDate} setDocumentDate={setDocumentDate}
                postingDate={postingDate} setPostingDate={setPostingDate}
                fiscalYear={fiscalYear} setFiscalYear={setFiscalYear}
                fiscalPeriod={fiscalPeriod} setFiscalPeriod={setFiscalPeriod}
                currency={currency} setCurrency={setCurrency}
                referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
                documentHeaderText={documentHeaderText} setDocumentHeaderText={setDocumentHeaderText}
                documentData={data}
              />
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Create Journal
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
};
//#endregion















//#region Filter
const FilterModal = ({
  visible, onClose, modalName,
  vendorFilter, setVendorFilter,
  statusFilter, setStatusFilter,
}) => {
  const [failMessage, setFailMessage] = useState("");
  const [_vendorFilter, _setVendorFilter] = useState(vendorFilter);
  const [_statusFilter, _setStatusFilter] = useState(statusFilter);

  useEffect(() => {
    if(visible){
      _setVendorFilter(vendorFilter)
      _setStatusFilter(statusFilter)
    }
  }, [visible, vendorFilter, statusFilter])

  const handleSubmit = async () => {
    setVendorFilter(_vendorFilter);
    setStatusFilter(_statusFilter);
    closeModal();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
  };

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  };



//#region Vendor
  const [showVendorSelectForm, setShowVendorSelectForm] = useState(false);
  const openVendorSelectForm = () => {
    setShowVendorSelectForm(true);
  }
  const closeVendorSelectForm = () => {
    setShowVendorSelectForm(false);
  }
//#endregion

  if (!visible) return null;

  return (
    <>
      {/* Background overlay */}
      <AnimatePresence>
        {visible && (
          <motion.div
            // initial={{ opacity: 0 }}
            // animate={{ opacity: 1 }}
            // exit={{ opacity: 0 }}
            className="fixed inset-0 bg-gray-200 bg-opacity-70 flex items-center justify-center z-50"
          >
            {/* Modal container */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="bg-gray-100 rounded-2xl shadow-lg w-full max-w-lg p-8"
            >
              <h2 className="text-2xl font-semibold border-b pb-3 mb-6">
                {modalName}
              </h2>

              <div className="space-y-5 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px] pr-1">
                <div>
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Vendor <span className="text-red-500">*</span>
                  </label>
                  <div className="flex flex-row items-center">
                    <input
                      type="text"
                      placeholder="Select Vendor"
                      className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                      value={`${_vendorFilter ? `${_vendorFilter?.vendorId} - ${_vendorFilter?.name1}` : ""}`}
                      readOnly
                    />
                    {!_vendorFilter ?
                      <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openVendorSelectForm}>
                        <PersonSearchIcon className="text-white"/>
                      </button> 
                      :
                      <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>_setVendorFilter(null)}>
                        <RemoveCircleIcon className="text-white"/>
                      </button>
                    }
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">
                    Status
                  </label>
                  <PaymentStatusSelectWithAll data={_statusFilter} setData={_setStatusFilter} isEditable={true}/>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex justify-end space-x-3 mt-8 border-t pt-4">
                <button
                  onClick={closeModal}
                  className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="px-5 py-2 rounded-lg bg-theme-color text-white font-medium hover:opacity-90 transition"
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <VendorSelect 
        visible={showVendorSelectForm} 
        onClose={closeVendorSelectForm}
        modalName={"Select Vendor"}
        data={_vendorFilter} setData={_setVendorFilter}
      />

      {/* Alert */}
      <div className="fixed top-5 right-5 z-[9999] flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
//#endregion